import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 1. Define your translations
const resources = {
  en: {
  translation: {
   "general": {
      "install-app": "Install somos+ app",
      "apply": "Apply",
      "approve": "Approve",
      "back": "Back",
      "cancel": "Cancel",
      "close": "Close",
      "confirm": "Confirm",
      "delete": "Delete",
      "edit": "Edit",
      "enter": "Enter",
      "find": "Find",
      "loading": "Loading...",
      "next": "Next",
      "no": "No",
      "page-not-found": "Page not found",
      "page-not-found-desc": "The page you are looking for does not exist.",
      "go-home": "Go to home",
      "processing": "Processing...",
      "reject": "Reject",
      "reset": "Reset",
      "save": "Save",
      "search": "Search",
      "searching": "Searching...",
      "select": "Select",
      "selected": "Selected",
      "submit": "Submit",
      "update": "Update",
      "view": "View",
      "yes": "Yes",
      "time":{
        "days":{
          "monday": "Monday",
          "tuesday": "Tuesday",
          "wednesday": "Wednesday",
          "thursday": "Thursday",
          "friday": "Friday",
          "saturday": "Saturday",
          "sunday": "Sunday",
        },
        "hours":{
          "24-7": "Open 24/7",
          "add-hours": "Add hours",
          "alert-monday": "Set Monday's hours first.",
          "alert-confirm-reset": "Are you sure you want to clear all hours?",
          "business-hours": "Business hours",
          "closed": "Closed",
          "closes-at": "Closes at",
          "copy-monday": "Copy Monday's schedule to all days",
          "day": "Day",
          "hours": "Hours",
          "hours-help": "Set the opening hours for each day. Leave blank if closed.",
          "open": "Open",
          "opens-at": "Opens at",
          "remove-hours": "Remove hours",
          "to": "to",
          "variable-hours": "Variable hours",
        },
      },
      "install-prompt": {
        "title": "Install our App",
        "tap": "Tap the",
        "share-then": "\"Share\" icon then",
        "add-to-home": "\"Add to Home Screen\""
      },
     "alerts": {
         "registration-success": "You have registered succesfully! Please, check your email to confirm your address. Revise your spam folder",
         "action-success": "Action completed successfully!",
         "action-error": "Error completing action. Please try again.",
         "address-not-found": "Address not found. Please try a different format.",
         "error-geocoding": "Error retrieving location data. Please try again later.",
        "save-favourites": "Please, log in to save to favourites.",
        "error-geolocation": "Unable to retrieve your location."
        },
    },
      "company":{
        "legal-entity": "Proclade.ch",
        "address-1": "Wiedingstrasse, 46",
        "address-2": "8055 Zürich Switzerland",
        "legal-email": "info@proclade.ch",
        "report": "hello@somosmas.ch",
        "privacy-email": "hello@somosmas.ch",
        "dpo-email": "hello@somosmas.ch"
      },
    "common":{
      "we-use": "We use strictly necessary cookies ",
      "cookie-text": " to manage your login session and map preferences. By continuing to use this site, you agree to our usage of cookies.",
      "read-more" : "Read our Privacy policy.",
      "cookie-banner":
      {"acknowledge": "Acknowledge"}
    },
    "nav": {
      "brand-short": "SM",
      "brand": "Somos Mas",
      "map": "Map",
      "events": "Events",
      "dashboard": "Dashboard", 
      "admin": "Admin portal",
      "login": "Log in",
      "signout": "Sign out",
      "register": "Register",
      "profile": "Profile"
    },
    "admin":{
      "provider-manager":{
        "title": "Administrator portal",
      },
      "providers": "Providers",
      "events": "Events",
      "users": "Users",
      "pending": "Pending",
      "all": "All",
      "joined": "Joined",
      "no-results":"No results",
      "search-placeholder":"Search in this tab",
      "view-profile": "Profile",
      "unknown-user": "Unknown user",
      "no-name": "Unknown name",
      "providers":{
        "owner-account": "Owner account",
        "community-suggestion": "Community suggestion",
        "suggester-contact": "Suggester's contact",
        "anonymous-warning": "Anonymous submission — no registered account. Contact info belongs to the suggester, not a verified owner. Verify independently before approving.",
      },
      "filter": {
        "pending": "Pending",
        "all": "All",
      },
      "tabs": {
        "providers": "Providers",
        "events": "Events",
        "users": "Users",
      },
      "status": {
        "approved": "Approved",
        "active": "Active",
        "rejected": "Rejected",
        "live": "Live",
        "past": "Past",
        "pending": "Pending",
        "planned": "Planned",
        "deleted": "Deleted",
      },
      "users":{
        "unverified": "Unverified",
        "verified": "Validated",
        "favorites": "Favorites",
        "events": "Events",
        "business-listings": "Business listings",
        "no-listings-found": "No listings found",
      },
      "alerts":{
        "confirmDeleteUser": "Are you sure you want to delete this user? Be aware that this action is irreversible!",
        "confirmDeleteEvent": "Are you sure you want to delete this event? Be aware that this action is irreversible!",
        "confirmDeleteListing": "Are you sure you want to delete this service? Be aware that this action is irreversible!",
        "confirmRejectListing": "Are you sure you want to reject this service? Be aware that this action is irreversible!",
        "confirmRejectEvent": "Are you sure you want to reject this event? Be aware that this action is irreversible!",
      }
    },
    "reset-password": {
      "title": "Reset password",
      "email-placeholder": "Enter your email",
      "submit-button": "Send reset link",
      "update-button": "Update password",
      "set-new-password": "Set new password",
      "new-password": "New password",
      "update-password-button": "Update password",
      "alerts":{
        "reset-link-sent": "If the email exists, a reset link has been sent.",
        "reset-link-error": "Error sending reset link. Please try again later or contact support.",
        "password-update-success": "Password updated successfully! You can now log in with your new password.",
        "password-update-error": "Error updating password. Please try again or contact support.",
        "invalid-token": "Invalid or expired token. Please request a new password reset.",
        "invalid-credentials": "Invalid credentials or server error."
      },
      "forgot-password": "Forgot your password?",
    },
    "hero": {
        "title": "Services, events and a community to help you settle in and create real opportunities",
        "subtitle": "Connect, discover and grow in Switzerland",
        "cta": "Search services",
        "learn": "Search events",
        "suggest": "Suggest services",
        "newfeatures":"Have you just arrived in Switzerland? Do you need help?",
        "read": "Read more",
        "read-less": "Read less",
        "small-message": "Every time you use SOMOS+, you directly contribute to Proclade Schweiz's social projects.",
    },
    "events": {
        "title": "Community board",
        "search-button": "Search",
        "search-hint": "Press Enter to search",
        "upload-image": "Upload image",
        "image-hint": "JPG or PNG, max 5 MB",
        "choose-file": "Choose file",
        "event-image": "Event image",
        "hosted-by": "Hosted by",
        "start": "Start",
        "end": "End",
        "no-description": "No description provided.",
        "status": { "upcoming": "Upcoming" },
        "save-event": "Save event",
        "unsave-event": "Unsave event",
        "share": "Share",
        "share-event": "Share event",
        "link-copied": "Link copied to clipboard!",
        "modal": { "close": "Close" },
        "unknown-host": "Unknown host",
        "unpin-event": "Unpin event",
        "pin-event": "Pin event",
        "featured-events": "Highlights",
        "featuredCarousel": "Featured events",
        "upcoming-events": "Upcoming events",
        "pageTitle": "Events",
        "subtitle": "Discover what's happening in your community",
        "breadcrumb.home": "Home",
        "dateStrip": { "today": "Today", "tomorrow": "Tomorrow" },
        "sections": { "thisWeekend": "This Weekend", "justAnnounced": "Just Announced", "trending": "Trending Now" },
        "showing": "Showing {{count}} events",
        "sort": { "dateAsc": "Date · Soonest first", "newest": "Newest", "providerAsc": "Provider · A–Z" },
        "viewDetails": "View details",
        "viewOnMap": "View on map",
        "backToTop": "Back to top",
        "noResultsTitle": "No events match your filters",
        "noResultsBody": "Try adjusting your search or clearing filters.",
        "clearFilters": "Clear filters",
        "event-management":{
          "title": "Event management",
          "subtitle": "Manage your schedule and showcase your services.",
          "no-events-yet": "No events yet",
          "no-events-yet-desc": "Create your first event using the form.",
          "create-event": "Create event",
          "active-events": "Active events",
          "past-events": "Past events",
          "event-title": "Event title",
          "event-title-placeholder": "e.g. Summer Sale",
          "event-type": {
            "title": "Category",
            "community": "Community",
            "sale": "Sale",
            "food": "Food",
            "music": "Music",
            "workshop": "Workshop",
          },
          "alerts": {
            "event-created": "Event created successfully! Administrators will review it shortly.",
            "event-creation-failed": "Error creating event. Please try again or contact support.",
            "event-update": "Event updated successfully! Administrators will review it shortly.",
            "event-update-failed": "Error updated event. Please try again or contact support.",
            "event-deleted": "Event deleted successfully.",
            "event-deletion-failed": "Error deleting event. Please try again or contact support.",
            "event-sure-delete": "Are you sure you want to delete this event? This action is irreversible.",
          },
          "event-button": "Publish event",
          "no-active-events": "You have no active events.",
          "no-past-events": "You have no past events.",
          "no-services-found": "No services available.",
          "service": "Service",
          "search-by-description": "Search by description...",
          "search-by-service-provider": "Search by service provider...",
          "log-in-prompt": "Please log in to manage your events.",
          "recurrence": {
            "label": "Repeat",
            "none": "No repeat",
            "weekly": "Weekly",
            "monthly": "Monthly",
            "end-date": "Repeat until"
          },
          "location": {
            "title": "Location",
            "use-provider": "Use business address",
            "custom": "Custom location",
            "name": "Venue name",
            "address": "Address",
            "pick-on-map": "Pick on map",
            "view-on-map": "View on map"
          },
          "description": "Description"
        },
    },
    "calendar": {
        "next": "Next",
        "previous": "Back",
        "today": "Today",
        "month": "Month",
        "week": "Week",
        "date": "Date",
        "time": "Time",
        "event": "Event",
        "agenda": "Agenda",
        "day": "Day",
        "noEvents": "No events in this range"
      },
    "search": {
      "placeholder": "Search services, descriptions...",
      "filters": "Filters",
      "showing": "Showing ",
      "results": "results",
    },
      "feature": {
        "title": "",
        "short": "Find support, services and a community to help you settle into life in Switzerland",
        "description": "Find out more about <historyLink>our History</historyLink> and the programmes we support in Switzerland",
        "acoge-title": "ACOGE program",
        "acoge-description": "Guides you through your first steps in Switzerland with key information and connections to local services.",
        "acoge-cta": "Read more",
        "cuenta-title": "Cuenta Conmigo",
        "cuenta-description": "Access a support network and a practical guide with everything essential for your life in Switzerland.",
        "cuenta-cta": "Explore guide",
        "cuenta-manual-supervivencia": "Explore the guide (available in Spanish only)",
        "cuenta-description2": "Stay updated with the latest events, sales, and news from your favorite providers.",
        "lugar-title": "Un lugar de afuera",
        "lugar-description": "Real stories and conversations that accompany you through your migration journey.",
        "lugar-cta": "Read more",
    },
    "history": {
        "title": "Our History",
        "intro": "SOMOS+ is a project of PROCLADE SCHWEIZ, a member of the international PROCLADE NGO network. It was born not from an idea, but from experience: years of working alongside the Spanish-speaking community in Switzerland, listening, accompanying and closely understanding the challenges, needs and hopes that are part of the migration experience.",
        "origins-title": "Our Origins",
        "origins-p1": "Our story began in 2016, when a group of MCLE volunteers decided to accompany Spanish-speaking individuals and families in their first steps in Switzerland, convinced that a close reception and timely support could prevent many of the personal, family and social difficulties that often accompany the migration experience.",
        "origins-p2": "Very soon we understood that, beyond information, people needed something even more valuable: to feel welcomed, guided and to know they were not alone. From that experience, projects such as the Family Accompaniment Programme, Cuenta Conmigo and Urbamapp (our first geolocated map) were born, each created in response to the real needs we were discovering alongside the community itself.",
        "evolution-title": "Our Evolution",
        "evolution-p1": "Over the years we understood that a further step was needed. That is how PROCLADE SCHWEIZ was born: to gather all that experience, give it continuity and expand its impact; to strengthen the initiatives developed in Switzerland, promote the international cooperation of the PROCLADE network and create self-financing models that would enable the growth of new support programmes such as ACOGE, the podcast Un lugar de afuera and SOMOS+.",
        "evolution-p2": "Today, SOMOS+ is the expression of that journey and this experience. Because a recommendation can open a door, guidance can avoid months of uncertainty and possible mistakes, but a united community can make a new country feel like home.",
        "invitation-title": "Write this story with us",
        "invitation": "SOMOS+ is not a finished platform, but an opportunity for every Spanish-speaking person living in Switzerland to contribute, suggest and propose. Because the best information is not built by an institution, but by people who share their experience so that others can walk the path with more support. From now on, this story is written by all of us."
    },
    "landing": {
        "carousel-alt": "Community photos",
        "section-heading": "One community. Two opportunities.",
        "comunidad-label": "COMMUNITY",
        "comunidad-heading": "Find support, services and opportunities.",
        "comunidad-item-1": "Trusted professionals.",
        "comunidad-item-2": "Nearby businesses.",
        "comunidad-item-3": "Events and activities.",
        "comunidad-item-4": "Useful information for your integration.",
        "comunidad-cta": "I want to discover",
        "proveedores-label": "PROVIDERS",
        "proveedores-heading": "Connect with people who need what you offer.",
        "proveedores-item-1": "More visibility.",
        "proveedores-item-2": "More business opportunities.",
        "proveedores-item-3": "More social impact.",
        "proveedores-cta": "I want to connect",
        "impacto-heading": "Our Impact",
        "impacto-description": "With your participation and support, we contribute to creating <blue>opportunities</blue>, <blue>well-being</blue> and <orange>hope</orange> for people who need it most.",
        "impacto-cta-latam": "Discover some of our projects in Latin America",
        "impacto-cta-world": "Discover our work around the world",
        "encuentra-heading": "Find what you're looking for in one place. Free!",
        "comunidad-modal": {
            "label": "COMMUNITY",
            "heading": "Join <highlight>FOR FREE</highlight>",
            "intro": "Join SOMOS+ for free, the community that connects Spanish speakers in Switzerland to find services, opportunities, information and people who make life easier away from home.",
            "benefits-heading": "What benefits do you get as a user?",
            "benefit-1-title": "Exclusive benefits and promotions",
            "benefit-1-desc": "Access discounts, promotions and special benefits offered by the businesses and professionals who are part of SOMOS+.",
            "benefit-2-title": "Free courses and training",
            "benefit-2-desc": "Participate in workshops, conferences, mentorships and training spaces organized by SOMOS+ and its partners.",
            "benefit-3-title": "Events and networking",
            "benefit-3-desc": "Receive invitations to gatherings, fairs, cultural activities and events where you can expand your contact network and discover new opportunities.",
            "benefit-4-title": "Find trusted services",
            "benefit-4-desc": "Easily locate professionals, businesses and services recommended by the community.",
            "benefit-5-title": "Save your favorites and filter listings by preferences",
            "benefit-5-desc": "Create your own list of businesses, services and professionals to access them when you need them and filter your listings.",
            "impact-title": "Your registration also generates impact",
            "impact-desc": "By registering at SOMOS+, you also contribute to driving social and humanitarian initiatives promoted by PROCLADE SCHWEIZ, generating opportunities, well-being and hope both in Switzerland and in various countries of Latin America.",
            "tagline": "More benefits. More opportunities. More community.",
            "explore-map": "Explore the map",
            "close": "Close"
        },
        "proveedores-modal": {
            "label": "PROVIDERS",
            "heading": "Welcome to",
            "intro-1": "Join SOMOS+, an ecosystem that connects entrepreneurs, professionals and businesses with the Spanish-speaking community in Switzerland.",
            "intro-2": "With a single membership you increase the visibility of your business and, at the same time, contribute to generating opportunities, well-being and hope for people who need it most in Latin America.",
            "benefits-heading": "What does your membership include?",
            "benefits-tagline": "Your business grows. Lives are transformed.",
            "badge-line-1": "Your business grows.",
            "badge-line-2": "Lives are transformed.",
            "benefit-1-title": "Professional profile all year",
            "benefit-1-desc": "Your business visible all year round on SOMOS+.",
            "benefit-2-title": "Publication of your services",
            "benefit-2-desc": "Present your company in a clear, attractive and organized way.",
            "benefit-3-title": "3 posts per year",
            "benefit-3-desc": "Includes 3 promotional posts on the platform.",
            "benefit-4-title": "Social media promotion",
            "benefit-4-desc": "We promote your business on Facebook, Instagram and channels.",
            "benefit-5-title": "WhatsApp community",
            "benefit-5-desc": "Be part of an active network to share news.",
            "benefit-6-title": "Events and networking",
            "benefit-6-desc": "Access fairs, meetings, training and more.",
            "benefit-7-title": "Customer contact",
            "benefit-7-desc": "Interested people will be able to contact you.",
            "benefit-8-title": "Greater visibility",
            "benefit-8-desc": "Position yourself in a trusted ecosystem in your language.",
            "benefit-9-title": "Training and growth",
            "benefit-9-desc": "Participate in workshops and talks to strengthen your business.",
            "benefit-10-title": "Community with purpose",
            "benefit-10-desc": "20% goes to social projects in Latin America.",
            "price-label": "Your Investment",
            "price-period": "CHF / year",
            "price-amount": "360",
            "price-note": "Approximately CHF 1 per day.",
            "price-freeze": "The value of your membership will remain frozen for 2 years for those who register at this stage.",
            "price-promise": "No increases. No surprises.",
            "impact-heading": "More than a membership, a real impact",
            "impact-1": "Your business gains visibility, new customers and more opportunities.",
            "impact-2": "You strengthen your positioning within the Spanish-speaking community.",
            "impact-3": "You contribute to transforming lives through social projects.",
            "cta-heading": "Do you want to be part of SOMOS+?",
            "cta-desc": "Write to us and we will be happy to guide you through the process.",
            "close": "Close"
        }
    },
     "map": {
         "search-address-click-map": "Search an address",
         "click-map-drop-pin": "Drop a pin clicking on the map",
         "or": "OR",
         "website": "Website",
         "add-service": "Suggest a service",
         "required-fields-notice": "Only fields marked with an asterisk (*) are required",
         "add-service-hint": "Know a local service? Suggest it!",
         "change": "Modify",
         "business-name":"Service name",
         "email":"Email",
         "call":"Call",
         "both":"Both",
         "phone":"Phone",
         "step1":"Step 1: Set location",
         "step1-description": "Click anywhere on the map.",
         "description":"Service description",
         "contact": "Contact info (required to validate service)",
         "contact-required": "Please provide at least an email or phone number so we can verify this suggestion.",
         "preferred-contact":"Preferred contact method:",
         "new-location-set":"New service set! We will contact you soon to validate the data.",
         "edit-service": "Edit service",
         "delete-service": "Delete service",
         "service-form-title": "Service details",
         "service-name": "Service name",
         "service-description": "Description",
         "service-category": "Category",
         "service-location": "Location",
         "service-submit": "Submit",
         "service-cancel": "Cancel",
         "service-delete-confirm": "Are you sure you want to delete this service?",
         "service-no-providers": "No providers found in this area.",
         "category": "Category",
         "tier": "Tier",
         "premium": "Premium",
         "basic": "Basic service",
         "silver": "Silver tier",
         "platinum": "Platinum tier",
         "submit-request": "Submit request",
         "filters": "Filters",
         "reset-filters": "Reset filters",
         "results-singular": "result",
         "results-plural":"results",
         "all-categories": "All",
         "general-category": "General",
         "all": "All",
         "general": "General",
         "gastronomy": "Gastronomy",
         "shops": "Shops",
         "health": "Health",
         "education": "Education",
         "services": "Services",
         "welness": "Wellness",
         "wellness": "Wellness",
         "technical": "Technical",
         "culture": "Culture",
         "active": "Active",
         "expired": "Expired",
         "pending": "Pending",
         "rejected": "Rejected",
         "business-directory": "Service directory",
         "location-confirmed": "Location confirmed",
         "set-your-location": "Set location *",
         "search-address-click-map": "Search an address or click the map",
         "enter-address": "Enter address…",
         "search": "Search",
         "click-map-drop-pin": "📍 Click anywhere on the map to drop a pin",
         "coords": "Coords:",
         "change": "Change",
         "website": "Website",
         "website-placeholder": "https://…",
         "phone-placeholder": "Phone Number (e.g. +41 …)",
         "email-placeholder": "Public email",
         "results-singular": "result",
         "results-plural": "results",
         "visit-website": "Visit website →",
         "share": "Share",
         "link-copied": "Link copied to clipboard!",
         "group-title": "{n} services here",
         "group-back": "Back to list",
         "hours": {
           "open247": "Open 24/7",
           "variable": "Variable Hours",
           "closed": "Closed",
           "open": "Open",
           "open24h": "Open 24h"
         },
         "days": {
           "monday": "Mon",
           "tuesday": "Tue",
           "wednesday": "Wed",
           "thursday": "Thu",
           "friday": "Fri",
           "saturday": "Sat",
           "sunday": "Sun"
         }
       },
    "footer": {
      "description": "We connect the Spanish-speaking community in Switzerland with services, opportunities and a network that supports you in your daily life",
      "platform": "PLATFORM",
      "map": "Explore services",
      "provider": "Easy access",
      "community": "Events and community",
      "contact": "SUPPORT",
      "help": "Help center and support",
      "privacy": "Privacy policy",
      "terms-of-service": "Terms of service",
      "rights": "Proclade Schweiz. All rights reserved."
    },
    "alerts": {
      "alert-location-error": "Unable to retrieve your location.",
      "alert-fetch-error": "Error fetching providers. Please try again later.",
      "alert-submit-success": "Service submitted successfully!",
      "alert-submit-error": "Error submitting service. Please try again.",
      "alert-submit-location": "Please, click on the map to select a location.",
      "alert-reset-password-success-message": "If an account with that email exists, a reset link has been sent."
    },
    "buttons": {
      "submit-request": "Submit request",
      "processing": "Processing...",
      "cancel": "Cancel",
      "delete": "Delete",
      "reset-filters": "Reset filters"
    },
   "terms": {
  "terms-and-conditions": "General Terms and Conditions (GTC)",
  "updated": "Last updated: February 13, 2026",
  "introduction": "1. Scope of Application",
  "introduction-1": "These GTC apply to the use of the Somos Más platform by operators, users, and service providers.",
  "introduction-2": "",
  "user-accounts": "2. Services",
  "user-account-cond1": "Somos Más provides a technical infrastructure for the mediation of services and events.",
  "user-account-cond2": "",
  "user-account-cond3": "",
  "user-account-cond4": "",
  "service-providers": "3. Role of Intermediary",
  "service-providers-intro": "Somos Más acts solely as an intermediary. Contracts are formed exclusively between users and service providers.",
  "service-providers-cond1": "",
  "service-providers-cond2": "",
  "service-providers-cond3": "",
  "service-providers-cond4": "",
  "compliance-header": "4. Responsibility for Content",
  "compliance-1": "Service providers are solely responsible for the accuracy of their information (prices, locations, images). Illegal content will be deleted immediately.",
  "compliance-2": "",
  "compliance-2-text": "",
  "compliance-3": "",
  "data-protection": "5. Fees and Billing",
  "data-protection-1": "",
  "right-to-access": "",
  "right-to-be-forgotten": "",
  "data-portability": "",
  "right-to-access-text": "The use for private users is free of charge.",
  "right-to-be-forgotten-text": "Fees (e.g., for profiles or premium entries) may apply to service providers.",
  "data-portability-text": "Invoices are sent electronically via email. In the event of late payment, the profile may be blocked.",
  "further-rights": "",
  "limitation-of-liability": "6. Limitation of Liability",
  "limitation-1": "The operator's liability for negligence and for damages caused by third parties is excluded.",
  "dispute-resolutions": "7. Applicable Law & Jurisdiction",
  "dispute-1": "Swiss law applies. The place of jurisdiction is Zurich, Switzerland.",
  "contact-us": "",
  "contact-1": "For legal inquiries or support: ",
  "acknowledge": "By using this website, you acknowledge that you have read and understood these terms."
},
    "privacy": {
  "header": {
    "title": "Privacy Policy",
    "effectiveDate": "Effective from: February 13, 2026"
  },
  "sections": {
    "intro": {
      "title": "1. Introduction",
      "content": "We protect your personal data in accordance with the Swiss Data Protection Act (nFADP) and the EU GDPR.",
      "compliance": ""
    },
    "data": {
      "title": "2. Data Collection",
      "description": "We collect identity data (name), contact data (email), technical data (IP address), and location data (only with your consent for the map)."
    },
    "usage": {
      "title": "3. Data Usage",
      "description": "The data is used for registration, displaying services in your vicinity, and platform security."
    },
    "cookies": {
      "title": "4. Cookies",
      "body": "We use necessary cookies for the login area. Analytical cookies are only set with your consent.",
      "body-2": ""
    },
    "retention": {
      "title": "5. Data Retention",
      "body": "Data is deleted as soon as it is no longer required, unless there is a legal obligation to retain it (e.g., 10 years for invoices).",
      "body-2": ""
    },
    "rights": {
      "title": "6. Your Rights",
      "description": "You have the right to access, correct, and delete your data. (Contact us at: dpo@somosmas.ch):",
      "further-rights": "If you wish to exercise any of the rights mentioned above, please contact us."
    },
    "contact": {
      "title": "7. Contact Information",
      "officer": "Data Protection Officer:",
      "authority": "You have the right to file a complaint at any time with the Federal Data Protection and Information Commissioner (FDPIC) — the Swiss supervisory authority for data protection — via https://www.edoeb.admin.ch or by contacting the FDPIC at FDPIC, Feldeggweg 1, CH-3003 Bern."
    }
  },
  "footer": {
    "copy": "Privacy Policy of Somos Más"
  }
},
    "provider-analytics": {
      "loading": "Loading statistics...",
      "title": "Provider Analytics",
      "subtitle": "Performance and reach of your business",
      "total-favorites": "Total Favorites",
      "favorites-desc": "Users who have saved your profile",
      "saved-events": "Saved Events",
      "events-desc": "Interest in your {{count}} active events",
      "community-reach": "Community Reach",
      "reach-desc": "Total positive interactions",
      "cta-title": "Boost your visibility!",
      "cta-desc": "Businesses that regularly publish events are 40% more likely to be added to favorites. Post something new today!",
      "manage-events": "Manage My Events"
    },
    "provider-dashboard": {
      "title": "Grow your business with somos+",
      "subtitle": "Connect with the community, advertise your services and help more people find you",
      "card-1": "My business",
      "text-1": "List my business.",
      "button-1": "Manage services",
      "card-2": "Announcements",
      "text-2": "Post events and offers to connect with the the community.",
      "button-2": "Create publication",
      "card-3": "Analytics",
      "text-3": "Find out how many people see your business and interact with you.",
      "button-3": "View stats"
    },
    "profile": {
      "title": "User settings",
      "account": "Account",
      "full-name": "User name",
      "full-name-placeholder": "Enter your full name",
      "user": "User",
      "provider": "Provider",
      "admin": "Administrator",
      "email": "Email",
      "email-not-changed": "Email cannot be changed",
      "password": "Password",
      "language": "Language",
      "English": "English",
      "Spanish": "Spanish",
      "French": "French",
      "German": "German",
      "location": "Location",
      "default-location": "Default location",
      "custom-location": "Custom location",
      "location-help": "Set where the map focuses when you log in. You can type a city or click on the map.",
      "location-placeholder": "Set your location by clicking on the map",
      "search-location": "Search city, zip or address",
      "find-location": "Find",
      "profile-loading": "Loading profile...",
      "update-profile": "Update profile",
      "not-a-member": "Not a member yet?",
      "buttons": {
         "update-profile": "Update profile",
         "loading": "Loading...",
      },
      "alerts": {
         "profile-update-success": "Profile updated successfully!",
         "profile-update-error": "Error updating profile. Please try again or contact support.",
         "profile-access": "You can only edit your own profile.",
         "agree-terms-conditions":"You must agree to the terms and conditions to register.",
         "registration-failed": "Registration failed. Please try again or contact support.",
         "no-active-listings": "You have no active listings.",
         "confirm-delete-listing": "Are you sure you want to cancel this offering? It will be removed from the map.",
         "error-deleting-listing": "Error deleting service offering.",
      },
     "welcome": {
        "access-tools": "Access your tools to connect with the local community.",
        "already-member": "Already a member?",
        "agree-terms": "By registering, I agree to the ",
        "here-to": "I am here to:",
        "find-services": "Find services",
        "offer-services": "Offer services",
        "find-services-desc": "I want to browse and pin favorites.",
        "offer-services-desc": "I want to list my services on the map and create events.",
        "create-account": "Create account",
        "register-title": "Join somosmas",
        "register-subtitle": "We are more than just a map. We are a community.",
        "create-account-button": "Create account", 
     },
     "favorites": {
        "welcome": "Welcome back, ",
        "subtitle": "Here are your saved events and favorite service providers.",
        "saved-events": "Saved events",
        "favorite-providers": "Favorite services",
        "my-events": "My events",
        "favorite-services": "My favorite services",
        "browse-events": "Browse events",
        "explore-map": "Explore map",
        "open-route": "Open route",
        "visit-website": "Visit website",
        "save-calendar": "Save to calendar",
        "remove-favorite": "Remove from favorites",
        "view-details": "View details",
        "no-events": "You haven't pinned any events yet.",
        "find-events": "Find events",
        "no-places": "No favorite places yet.",
        "go-to-map": "Go to map",
        "unknown-venue": "Unknown Venue",
        "alerts": {
          "remove-event": "Remove this event from your dashboard?",
          "unpin-place": "Unpin this place?"
        },
    },
    "service-profile":{
      "title": "Edit service profile",
      "title-create": "Create service profile",
      "subtitle": "Update how your service appears on the public map.",
      "subtitle-create": "Link your account to the map by creating a public listing.",
      "business-name":"Service name",
      "description":"Service description",
      "refine-location":"Refine location",
      "website":"Website",
      "placeholder-email":"e.g. info@mybusiness.com",
      "placeholder-phone":"e.g. +41 79 123 45 67",
      "placeholder-location": "Type address (e.g. 10 Downing St. London) ",
      "preferred-contact":"How should customers contact you?",
      "address":"Address",
      "latitude":"Latitude",
      "longitude":"Longitude",
      "fine-tune": "Or click on the map to fine-tune the position.",
      "save-changes": "Save changes",
      "create-service": "Create service",
      "photo": "Service photo",
      "image-hint": "JPG or PNG, max 5 MB",
      "alerts":{
        "error-saving-profile": "Error saving profile.",
        "changes-saved": "Changes in service saved correctly.",
        "contact-recommended": "We recommend adding at least a phone or email.",
        "error-loading": "Error loading listing details."

      }
    },
   },
  }
},
  es: {
  translation: {
    "nav": {
      "brand-short": "SM",
      "brand": "Somos Mas",
      "map": "Mapa",
      "admin": "Portal admin",
      "login": "Acceso",
      "events": "Eventos",
      "dashboard": "Panel",
      "signout": "Cerrar sesión",
      "register": "Registrarse",
      "profile": "Perfil"
    },
    "common":{
      "we-use": "Usamos las cookies estrictamente necesarias ",
      "cookie-text": " para que puedas acceder a tu sesión y guardar tus preferencias del mapa. Si continúas usando el sitio, estás de acuerdo con el uso de las cookies.",
      "read-more" : "Lee nuestra política de privacidad.",
      "cookie-banner": {
        "acknowledge": "Aceptar"}
    },
    "admin":{
      "provider-manager":{
        "title": "Portal del administrador",
      },
      "providers": "Proveedores",
      "events": "Eventos",
      "users": "Usuarios",
      "pending": "Pendientes",
      "all": "Todos",
      "joined": "Registrado",
      "no-results":"Sin resultados",
      "search-placeholder":"Buscar en esta lista",
      "view-profile": "Ver perfil",
      "unknown-user": "Usuario desconocido",
      "no-name": "Nombre desconocido",
      "providers":{
        "owner-account": "Cuenta asociada",
        "community-suggestion": "Sugerencia comunitaria",
        "suggester-contact": "Contacto del usuario",
        "anonymous-warning": "Envío anónimo — sin cuenta registrada. Los datos de contacto pertenecen al remitente, no a un propietario verificado. Verifique de forma independiente antes de aprobar.",
      },
      "filter": {
        "pending": "Pendiente",
        "all": "Todos",
      },
      "tabs": {
        "providers": "Proveedores",
        "events": "Eventos",
        "users": "Usuarios",
      },
      "status": {
        "approved": "Aprobado",
        "pending": "Pendiente",
        "active": "Activo",
        "live": "Live",
        "past": "Pasado",
        "pending": "Pendiente",
        "planned": "Aceptado",
        "rejected": "Rechazado",
        "deleted": "Eliminado",
      },
      "users":{
        "unverified": "No verificado",
        "verified": "Validado",
        "favorites": "Favoritos",
        "events": "Eventos",
        "business-listings": "Servicios asociados",
        "no-listings-found": "No se han encontrado servicios",
      },
      "alerts":{
        "confirmDeleteUser": "¿Estás seguro que quieres eliminar este usuario? ¡Ten en cuenta que esta acción es irreversible!",
        "confirmDeleteEvent": "¿Estás seguro que quieres eliminar este evento? ¡Ten en cuenta que esta acción es irreversible!",
        "confirmDeleteListing": "¿Estás seguro que quieres eliminar este servicio? ¡Ten en cuenta que esta acción es irreversible!",
        "confirmRejectListing": "¿Estás seguro que quieres rechazar este servicio? ¡Ten en cuenta que esta acción es irreversible!",
        "confirmRejectEvent": "¿Estás seguro que quieres rechazar este evento? ¡Ten en cuenta que esta acción es irreversible!",
      }
    },
    "reset-password": {
      "title": "Recuperar contraseña",
      "email-placeholder": "Introduce tu correo electrónico",
      "submit-button": "Enviar enlace de restablecimiento",
      "update-button": "Actualizar contraseña",
      "set-new-password": "Establecer nueva contraseña",
      "new-password": "Nueva contraseña",
      "update-password-button": "Actualizar contraseña",
      "alerts":{
        "reset-link-sent": "Si el correo existe, se ha enviado un enlace de restablecimiento.",
        "reset-link-error": "Error al enviar el enlace de restablecimiento. Por favor, inténtalo más tarde o contacta con soporte.",
        "password-update-success": "¡Contraseña actualizada con éxito! Ahora puedes iniciar sesión con tu nueva contraseña.",
        "password-update-error": "Error al actualizar la contraseña. Por favor, inténtalo de nuevo o contacta con soporte.",
        "invalid-token": "Token inválido o expirado. Por favor, solicita un nuevo restablecimiento de contraseña.",
        "invalid-credentials": "Credenciales inválidas o error del servidor."
      }, 
      "forgot-password": "¿Olvidaste tu contraseña?",
    },
    "hero": {
        "title": "Servicios, eventos y comunidad para integrarte y generar oportunidades reales",
        "subtitle": "Conecta, encuentra y crece en Suiza",
        "cta": "Buscar servicios",
        "learn": "Buscar eventos",
        "suggest": "Sugerir servicios",
        "newfeatures":"¿Acabas de llegar a Suiza? ¿Necesitas ayuda?",
        "read": "Leer más",
        "read-less": "Contraer",
        "small-message": "Con cada uso de SOMOS+, contribuyes directamente a proyectos sociales de Proclade Schweiz.",
    },
    "events": {
        "title": "Tablón comunitario",
        "search-button": "Buscar",
        "search-hint": "Pulsa Enter para buscar",
        "hosted-by": "Organizado por",
        "start": "Inicio",
        "end": "Fin",
        "no-description": "No se proporcionó descripción.",
        "status": { "upcoming": "Próximo" },
        "modal": { "close": "Cerrar" },
        "save-event": "Guardar evento",
        "unsave-event": "Quitar evento guardado",
        "share": "Compartir",
        "share-event": "Compartir evento",
        "link-copied": "Enlace copiado al portapapeles!",
        "unknown-host": "Anfitrión desconocido",
        "unpin-event": "Desanclar evento",
        "pin-event": "Anclar evento",
        "upload-image": "Cargar imagen",
        "image-hint": "JPG o PNG, máx. 5 MB",
        "choose-file": "Escoger archivo",
        "event-image": "Imagen del evento",
        "featured-events": "Eventos destacados",
        "featuredCarousel": "Eventos destacados",
        "upcoming-events": "Próximos eventos",
        "pageTitle": "Eventos",
        "subtitle": "Descubre lo que está pasando en tu comunidad",
        "breadcrumb.home": "Inicio",
        "dateStrip": { "today": "Hoy", "tomorrow": "Mañana" },
        "sections": { "thisWeekend": "Este fin de semana", "justAnnounced": "Recién publicados", "trending": "Tendencia" },
        "showing": "Mostrando {{count}} eventos",
        "sort": { "dateAsc": "Fecha · Más próximos", "newest": "Más recientes", "providerAsc": "Proveedor · A–Z" },
        "viewDetails": "Ver detalles",
        "viewOnMap": "Ver en el mapa",
        "backToTop": "Volver arriba",
        "noResultsTitle": "No hay eventos que coincidan con tus filtros",
        "noResultsBody": "Intenta ajustar tu búsqueda o borrar los filtros.",
        "clearFilters": "Borrar filtros",
        "event-management":{
          "title": "Gestión de eventos",
          "subtitle": "Gestiona los eventos relacionados con tus servicios",
          "no-events-yet": "Sin eventos aún",
          "no-events-yet-desc": "Crea tu primer evento usando el formulario.",
          "create-event": "Crear evento",
          "active-events": "Eventos activos",
          "past-events": "Eventos pasados",
          "event-title": "Título del evento",
          "event-title-placeholder": "p.ej. Venta de verano",
          "event-type": {
            "title": "Categoría",
            "community": "Comunidad",
            "sale": "Venta",
            "food": "Comida",
            "music": "Música",
            "workshop": "Taller",
          },
          "alerts": {
            "event-created": "¡Evento creado con éxito! Los administradores lo revisarán en breve.",
            "event-creation-failed": "Error al crear el evento. Por favor, inténtalo de nuevo o contacta con soporte.",
            "event-update": "¡Evento actualizado con éxito! Los administradores lo revisarán en breve.",
            "event-update-failed": "Error al actualizar el evento. Por favor, inténtalo de nuevo o contacta con soporte.",
            "event-deleted": "Evento eliminado con éxito.",
            "event-deletion-failed": "Error al eliminar el evento. Por favor, inténtalo de nuevo o contacta con soporte.",
            "event-sure-delete": "¿Estás seguro de que deseas eliminar este evento? Esta acción es irreversible.",
          },
          "event-button": "Publicar evento",
          "no-active-events": "No tienes eventos activos.",
          "no-past-events": "No tienes eventos pasados.",
          "no-services-found": "No hay servicios disponibles.",
          "service": "Servicio",
          "search-by-description": "Buscar por descripción...",
          "search-by-service-provider": "Buscar por proveedor de servicios...",
          "log-in-prompt": "Por favor, inicia sesión para gestionar tus eventos.",
          "recurrence": {
            "label": "Repetición",
            "none": "Sin repetición",
            "weekly": "Semanal",
            "monthly": "Mensual",
            "end-date": "Repetir hasta"
          },
          "location": {
            "title": "Ubicación",
            "use-provider": "Usar dirección del negocio",
            "custom": "Ubicación personalizada",
            "name": "Nombre del lugar",
            "address": "Dirección",
            "pick-on-map": "Marcar en el mapa",
            "view-on-map": "Ver en el mapa"
          },
          "description": "Descripción"
        },
      },
    "calendar": {
        "next": "Siguiente",
        "previous": "Atrás",
        "today": "Hoy",
        "month": "Mes",
        "week": "Semana",
        "date": "Fecha",
        "time": "Hora",
        "event": "Evento",
        "agenda": "Agenda",
        "day": "Día",
        "noEvents": "No hay eventos en este rango",
      },
       "map": {
         "search-address-click-map": "Busca una dirección",
         "click-map-drop-pin": "Pon un marcador sobre el mapa",
         "or": "O",
         "add-service": "Sugiere un nuevo servicio",
         "required-fields-notice": "Sólo son obligatorios los campos marcados con un asterisco (*)",
         "add-service-hint": "¿Conoces un servicio local? ¡Sugiérelo!",
         "change": "Modificar",
         "business-name":"Nombre del servicio",
         "email":"Correo electrónico",
         "call":"Llamar",
         "both":"Ambos",
         "phone":"Teléfono",
         "step1":"Paso 1: Establecer ubicación",
         "step1-description": "Haz clic en cualquier parte del mapa.",
         "description":"Descripción del servicio",
         "contact": "Información de contacto (requerida para validar el servicio)",
         "contact-required": "Por favor, proporciona al menos un correo electrónico o número de teléfono para verificar esta sugerencia.",
         "preferred-contact":"Método de contacto preferido:",
         "new-location-set":"¡Nuevo servicio establecido! Nos pondremos en contacto contigo pronto para validar los datos.",
         "edit-service": "Editar servicio",
         "delete-service": "Eliminar servicio",
         "service-form-title": "Detalles del servicio",
         "service-name": "Nombre del servicio",
         "service-description": "Descripción",
         "service-category": "Categoría",
         "service-location": "Ubicación",
         "service-submit": "Enviar",
         "service-cancel": "Cancelar",
         "service-delete-confirm": "¿Estás seguro de que deseas eliminar este servicio?",
         "service-no-providers": "No se encontraron proveedores en esta área.",
         "category": "Categoría",
         "tier": "Nivel",
         "premium": "Premium",
         "basic": "Servicio básico",
         "silver": "Nivel plata",
         "platinum": "Nivel platino",
         "submit-request": "Enviar solicitud",
         "filters": "Filtros",
         "reset-filters": "Restablecer filtros",
         "results-singular": "resultado",
         "results-plural":"resultados",
         "all-categories": "Todas",
         "general-category": "General",
         "all": "Todas",
         "general": "General",
         "gastronomy": "Gastronomía",
         "shops": "Tiendas",
         "health": "Salud",
         "education": "Educación",
         "services": "Servicios",
         "welness": "Bienestar",
         "wellness": "Bienestar",
         "technical": "Técnico",
         "culture": "Cultura",
         "active": "Activo",
         "expired": "Expirado",
         "pending": "Pendiente",
         "rejected": "Rechazado",
         "business-directory": "Directorio de servicios",
         "location-confirmed": "Ubicación confirmada",
         "set-your-location": "Establece la ubicación *",
         "search-address-click-map": "Busca una dirección o haz clic en el mapa",
         "enter-address": "Introduce la dirección…",
         "search": "Buscar",
         "click-map-drop-pin": "📍 Haz clic en cualquier parte del mapa para colocar un pin",
         "coords": "Coordenadas:",
         "change": "Cambiar",
         "website": "Sitio web",
         "website-placeholder": "https://…",
         "phone-placeholder": "Número de teléfono (ej. +41 …)",
         "email-placeholder": "Correo electrónico público",
         "results-singular": "resultado",
         "results-plural": "resultados",
         "visit-website": "Visitar sitio web →",
         "share": "Compartir",
         "link-copied": "Enlace copiado al portapapeles!",
         "group-title": "{n} servicios aquí",
         "group-back": "Volver a la lista",
         "hours": {
           "open247": "Abierto 24/7",
           "variable": "Horario variable",
           "closed": "Cerrado",
           "open": "Abierto",
           "open24h": "Abierto 24h"
         },
         "days": {
           "monday": "Lun",
           "tuesday": "Mar",
           "wednesday": "Mié",
           "thursday": "Jue",
           "friday": "Vie",
           "saturday": "Sáb",
           "sunday": "Dom"
         }
       },
    "search": {
      "placeholder": "Buscar servicios, descripciones...",
      "filters": "Filtros",
      "showing": "Mostrando ",
      "results": "resultados",
    },
      "feature": {
        "title": "",
        "short": "Encuentra apoyo, servicios y comunidad para empezar tu vida en Suiza",
        "description": "Conoce más sobre <historyLink>Nuestra Historia</historyLink> y los programas que apoyamos en Suiza",
        "map-title": "Mapa interactivo",
        "map-description": "Localización visual de todos los servicios con filtros en tiempo real y ventanas emergentes detalladas.",
        "community-title": "Tablón comunitario",
        "community-description": "Mantente actualizado con los últimos eventos, ventas y noticias de tus proveedores favoritos.",
        "acoge-title": "Programa ACOGE",
        "acoge-description": "Te orienta en tus primeros pasos en Suiza con informacion clave y conexion a servicios locales.",
        "acoge-cta": "Leer más",
        "cuenta-title": "Cuenta Conmigo",
        "cuenta-description": "Accede a una red de apoyo y a una guia practica con lo esencial para tu vida en Suiza.",
        "cuenta-cta": "Explorar guía",
        "cuenta-manual-supervivencia": "Explorar guía.",
        "cuenta-description2": "Stay updated with the latest events, sales, and news from your favorite providers.",
        "lugar-title": "Un lugar de afuera",
        "lugar-description": "Historias reales y conversaciones que te acompanan en tu proceso migratorio.",
        "lugar-cta": "Leer más",
    },
    "history": {
        "title": "Nuestra Historia",
        "intro": "SOMOS+ es un proyecto de PROCLADE SCHWEIZ, miembro de la red internacional PROCLADE ONG. No nace de una idea, sino de una experiencia: años de trabajo junto a la comunidad hispanohablante en Suiza, escuchando, acompañando y comprendiendo de cerca los desafíos, las necesidades y las esperanzas que forman parte de la experiencia migratoria.",
        "origins-title": "Nuestros Orígenes",
        "origins-p1": "Nuestra historia comenzó en 2016, cuando un grupo de voluntarios de la MCLE decidió acompañar a personas y familias hispanohablantes en sus primeros pasos en Suiza, convencidos de que una acogida cercana y un acompañamiento oportuno podían prevenir muchas de las dificultades personales, familiares y sociales que suelen acompañar a la experiencia migratoria.",
        "origins-p2": "Muy pronto comprendimos que, además de información, las personas necesitaban algo aún más valioso: sentirse acogidas, orientadas y saber que no estaban solas. De esa experiencia fueron naciendo proyectos como el Programa de Acompañamiento Familiar, Cuenta Conmigo y Urbamapp (nuestro primer mapa geolocalizado), cada uno creado como respuesta a las necesidades reales que íbamos descubriendo junto a la propia comunidad.",
        "evolution-title": "Nuestra Evolución",
        "evolution-p1": "Con los años entendimos que era necesario dar un paso más. Así nació PROCLADE SCHWEIZ, para recoger toda esa experiencia, darle continuidad y ampliar su impacto; fortalecer las iniciativas desarrolladas en Suiza, impulsar la cooperación internacional de la red PROCLADE y crear modelos de autofinanciación que hicieran posible el crecimiento de nuevos programas de apoyo como ACOGE, el pódcast Un lugar de afuera y SOMOS+.",
        "evolution-p2": "Hoy, SOMOS+ es la expresión de ese recorrido y de esta experiencia. Porque una recomendación puede abrir una puerta, una orientación puede evitar meses de incertidumbre y posibles errores, pero una comunidad unida puede hacer que un nuevo país se pueda sentir como un hogar.",
        "invitation-title": "Escribe esta historia con nosotros",
        "invitation": "Y hay que decir que SOMOS+ no es una plataforma terminada, sino una oportunidad para que cada persona hispanohablante radicada en Suiza aporte, sugiera y proponga. Porque la mejor información no la construye una institución, sino las personas que comparten su experiencia para que otros puedan recorrer el camino con más apoyo. A partir de ahora, esta historia la escribimos entre todos."
    },
    "landing": {
        "carousel-alt": "Fotos de la comunidad",
        "section-heading": "Una comunidad. Dos oportunidades.",
        "comunidad-label": "COMUNIDAD",
        "comunidad-heading": "Encuentra apoyo, servicios y oportunidades.",
        "comunidad-item-1": "Profesionales de confianza.",
        "comunidad-item-2": "Negocios cercanos.",
        "comunidad-item-3": "Eventos y actividades.",
        "comunidad-item-4": "Información útil para tu integración.",
        "comunidad-cta": "Quiero descubrir",
        "proveedores-label": "PROVEEDORES",
        "proveedores-heading": "Conecta con personas que necesitan lo que ofreces.",
        "proveedores-item-1": "Más visibilidad.",
        "proveedores-item-2": "Más oportunidades de negocio.",
        "proveedores-item-3": "Más impacto social.",
        "proveedores-cta": "Quiero conectar",
        "impacto-heading": "Nuestro Impacto",
        "impacto-description": "Con tu participación y apoyo, contribuimos a generar <blue>oportunidades</blue>, <blue>bienestar</blue> y <orange>esperanza</orange> para personas que más lo necesitan.",
        "impacto-cta-latam": "Conoce algunos de nuestros proyectos en América Latina",
        "impacto-cta-world": "Conoce nuestro trabajo en el mundo",
        "encuentra-heading": "Encuentra lo que buscas en un solo lugar. ¡Gratis!",
        "comunidad-modal": {
            "label": "COMUNIDAD",
            "heading": "Únete <highlight>GRATUITAMENTE</highlight> a ",
            "intro": "Únete GRATUITAMENTE a SOMOS+, la comunidad que conecta a los hispanohablantes en Suiza para encontrar servicios, oportunidades, información y personas que hacen más fácil la vida lejos de casa.",
            "benefits-heading": "¿Qué beneficios obtiene como usuario?",
            "benefit-1-title": "Beneficios y promociones exclusivas",
            "benefit-1-desc": "Acceda a descuentos, promociones y beneficios especiales ofrecidos por los negocios y profesionales que forman parte de SOMOS+.",
            "benefit-2-title": "Cursos y capacitaciones gratuitas",
            "benefit-2-desc": "Participe en talleres, conferencias, mentorías y espacios de formación organizados por SOMOS+ y sus aliados.",
            "benefit-3-title": "Eventos y networking",
            "benefit-3-desc": "Reciba invitaciones a encuentros, ferias, actividades culturales y eventos donde podrá ampliar su red de contactos y descubrir nuevas oportunidades.",
            "benefit-4-title": "Encuentre servicios de confianza",
            "benefit-4-desc": "Localice fácilmente profesionales, emprendimientos y negocios recomendados por la comunidad.",
            "benefit-5-title": "Guarde sus favoritos y filtre anuncios por preferencias",
            "benefit-5-desc": "Cree su propia lista de negocios, servicios y profesionales para acceder a ellos cuando los necesite y filtre sus anuncios y publicaciones.",
            "impact-title": "Su registro también genera impacto",
            "impact-desc": "Al registrarse en SOMOS+, usted también contribuye a impulsar iniciativas sociales y humanitarias promovidas por PROCLADE SCHWEIZ, generando oportunidades, bienestar y esperanza tanto en Suiza como en distintos países de Hispanoamérica.",
            "tagline": "Más beneficios. Más oportunidades. Más comunidad.",
            "explore-map": "Explorar el mapa",
            "close": "Cerrar"
        },
        "proveedores-modal": {
            "label": "PROVEEDORES",
            "heading": "Bienvenido a ",
            "intro-1": "Únete a SOMOS+, un ecosistema que conecta emprendedores, profesionales y negocios con la comunidad hispanohablante en Suiza.",
            "intro-2": "Con una sola membresía aumentas la visibilidad de tu negocio y, al mismo tiempo, contribuyes a generar oportunidades, bienestar y esperanza para personas que más lo necesitan en América Latina.",
            "benefits-heading": "¿Qué incluye tu membresía?",
            "benefits-tagline": "Tu negocio crece. Vidas se transforman.",
            "badge-line-1": "Tu negocio crece.",
            "badge-line-2": "Vidas se transforman.",
            "benefit-1-title": "Perfil profesional todo el año",
            "benefit-1-desc": "Tu negocio visible durante todo el año en SOMOS+.",
            "benefit-2-title": "Publicación de tus servicios",
            "benefit-2-desc": "Presenta tu empresa de forma clara, atractiva y organizada.",
            "benefit-3-title": "3 publicaciones al año",
            "benefit-3-desc": "Incluye 3 publicaciones promocionales en la plataforma.",
            "benefit-4-title": "Difusión en redes sociales",
            "benefit-4-desc": "Promocionamos tu negocio en Facebook, Instagram y canales.",
            "benefit-5-title": "Comunidad de WhatsApp",
            "benefit-5-desc": "Forma parte de una red activa para compartir novedades.",
            "benefit-6-title": "Eventos y networking",
            "benefit-6-desc": "Accede a ferias, encuentros, capacitaciones y más.",
            "benefit-7-title": "Contacto con clientes",
            "benefit-7-desc": "Las personas interesadas podrán comunicarse contigo.",
            "benefit-8-title": "Mayor visibilidad",
            "benefit-8-desc": "Posiciónate en un ecosistema confiable en tu idioma.",
            "benefit-9-title": "Formación y crecimiento",
            "benefit-9-desc": "Participa en talleres y charlas para fortalecer tu negocio.",
            "benefit-10-title": "Comunidad con propósito",
            "benefit-10-desc": "El 20% se destina a proyectos sociales en América Latina.",
            "price-label": "Tu Inversión",
            "price-period": "CHF / año",
            "price-amount": "360",
            "price-note": "Aproximadamente CHF 1 al día.",
            "price-freeze": "El valor de tu membresía permanecerá congelado durante 2 años para quienes se registren en esta etapa.",
            "price-promise": "Sin aumentos. Sin sorpresas.",
            "impact-heading": "Más que una membresía, un impacto real",
            "impact-1": "Tu negocio gana visibilidad, nuevos clientes y más oportunidades.",
            "impact-2": "Fortaleces tu posicionamiento dentro de la comunidad hispanohablante.",
            "impact-3": "Contribuyes a transformar vidas a través de proyectos sociales.",
            "cta-heading": "¿Quieres formar parte de SOMOS+?",
            "cta-desc": "Escríbenos y con gusto te acompañaremos durante el proceso.",
            "close": "Cerrar"
        }
    },
    "footer": {
      "description": "Conectamos a la comunidad hispanohablante en Suiza con servicios, oportunidades y una red que te acompaña en tu día a día",
      "platform": "PLATAFORMA",
      "map": "Explorar servicios",
      "provider": "Ingresa fácilmente",
      "community": "Eventos y comunidad",
      "contact": "SOPORTE",
      "help": "Centro de ayuda y soporte",
      "privacy": "Política de privacidad",
      "terms-of-service": "Términos de servicio",
      "rights": "Proclade Schweiz. Todos los derechos reservados."
    },
    "alerts": {
      "alert-location-error": "No se pudo obtener tu ubicación.",
      "alert-fetch-error": "Error al obtener los proveedores. Por favor, inténtalo más tarde.",
      "alert-submit-success": "¡Servicio enviado con éxito!",
      "alert-submit-error": "Error al enviar el servicio. Por favor, inténtalo de nuevo.",
      "alert-submit-location": "Por favor, haz clic en el mapa para seleccionar una ubicación.",
      "alert-reset-password-success-message": "Si existe una cuenta con ese correo electrónico, se ha enviado un enlace de restablecimiento."
    },
    "buttons": {
      "submit-request": "Enviar formulario",
      "processing": "Procesando...",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "reset-filters": "Restablecer filtros"
    },
    "terms": {
  "terms-and-conditions": "Términos y Condiciones Generales (TyC)",
  "updated": "Última actualización: 13 de febrero de 2026",
  "introduction": "1. Ámbito de aplicación",
  "introduction-1": "Estos TyC se aplican al uso de la plataforma Somos Más por parte de operadores, usuarios y proveedores de servicios.",
  "introduction-2": "",
  "user-accounts": "2. Servicios",
  "user-account-cond1": "Somos Más proporciona una infraestructura técnica para la mediación de servicios y eventos.",
  "user-account-cond2": "",
  "user-account-cond3": "",
  "user-account-cond4": "",
  "service-providers": "3. Papel de intermediario",
  "service-providers-intro": "Somos Más es únicamente un intermediario. Los contratos se celebran exclusivamente entre usuarios y proveedores de servicios.",
  "service-providers-cond1": "",
  "service-providers-cond2": "",
  "service-providers-cond3": "",
  "service-providers-cond4": "",
  "compliance-header": "4. Responsabilidad del contenido",
  "compliance-1": "Los proveedores de servicios son los únicos responsables de la exactitud de su información (precios, ubicaciones, imágenes). El contenido ilegal será eliminado inmediatamente.",
  "compliance-2": "",
  "compliance-2-text": "",
  "compliance-3": "",
  "data-protection": "5. Tarifas y Facturación",
  "data-protection-1": "",
  "right-to-access": "",
  "right-to-be-forgotten": "",
  "data-portability": "",
  "right-to-access-text": "El uso para usuarios privados es gratuito.",
  "right-to-be-forgotten-text": "Para los proveedores de servicios pueden aplicarse tarifas (por ejemplo, por perfiles o anuncios premium).",
  "data-portability-text": "Las facturas se envían electrónicamente por correo electrónico. En caso de demora en el pago, el perfil puede ser bloqueado.",
  "further-rights": "",
  "limitation-of-liability": "6. Limitación de responsabilidad",
  "limitation-1": "Se excluye la responsabilidad del operador por negligencia, así como por daños causados por terceros.",
  "dispute-resolutions": "7. Ley aplicable y Jurisdicción",
  "dispute-1": "Se aplica la legislación suiza. El lugar de jurisdicción es Zúrich, Suiza.",
  "contact-us": "",
  "contact-1": "Para consultas legales o soporte: ",
  "acknowledge": "Al utilizar este sitio web, usted reconoce haber leído y comprendido estos términos."
},
    "privacy": {
  "header": {
    "title": "Política de Privacidad",
    "effectiveDate": "Vigente desde: 13 de febrero de 2026"
  },
  "sections": {
    "intro": {
      "title": "1. Introducción",
      "content": "Protegemos sus datos personales de acuerdo con la Ley Federal Suiza de Protección de Datos (nLPD) y el RGPD de la UE.",
      "compliance": ""
    },
    "data": {
      "title": "2. Recopilación de datos",
      "description": "Recopilamos datos de identidad (nombre), datos de contacto (correo electrónico), datos técnicos (dirección IP) y datos de ubicación (solo con su consentimiento para el mapa)."
    },
    "usage": {
      "title": "3. Uso de los datos",
      "description": "Los datos se utilizan para el registro, la visualización de servicios cercanos y la seguridad de la plataforma."
    },
    "cookies": {
      "title": "4. Cookies",
      "body": "Utilizamos las cookies necesarias para el área de inicio de sesión. Las cookies de análisis solo se instalan con su consentimiento.",
      "body-2": ""
    },
    "retention": {
      "title": "5. Conservación de datos",
      "body": "Los datos se eliminan tan pronto como dejan de ser necesarios, a menos que exista una obligación legal de conservación (por ejemplo, 10 años para las facturas).",
      "body-2": ""
    },
    "rights": {
      "title": "6. Sus derechos",
      "description": "Tiene derecho a la información, rectificación y supresión de sus datos. (Contáctenos en: hello@somosmas.ch):",
      "further-rights": "Si desea ejercer alguno de los derechos mencionados anteriormente, póngase en contacto con nosotros."
    },
    "contact": {
      "title": "7. Información de contacto",
      "officer": "Responsable de protección de datos:",
      "authority": "Tiene derecho a presentar una reclamación en cualquier momento ante el Comisionado Federal de Información y Protección de Datos (IFPD) —la autoridad de control suiza en materia de protección de datos— a través de https://www.edoeb.admin.ch o contactando con el IFPD en IFPD, Feldeggweg 1, CH-3003 Berna."
    }
  },
  "footer": {
    "copy": "Política de Privacidad de Somos Más"
  }
},
    "provider-analytics": {
      "loading": "Cargando estadísticas...",
      "title": "Analíticas del Proveedor",
      "subtitle": "Rendimiento y alcance de tu negocio",
      "total-favorites": "Favoritos Totales",
      "favorites-desc": "Usuarios que han guardado tu perfil",
      "saved-events": "Eventos Guardados",
      "events-desc": "Interés en tus {{count}} eventos activos",
      "community-reach": "Alcance de Comunidad",
      "reach-desc": "Total de interacciones positivas",
      "cta-title": "¡Aumenta tu visibilidad!",
      "cta-desc": "Los negocios que publican eventos regularmente tienen un 40% más de probabilidad de ser añadidos a favoritos. ¡Publica algo nuevo hoy!",
      "manage-events": "Gestionar Mis Eventos"
    },
    "provider-dashboard": {
      "title": "Haz crecer tu negocio con SOMOS+",
      "subtitle": "Conecta con la comunidad, publica tus servicios y haz que más personas los encuentren",
      "card-1": "Mi negocio",
      "text-1": "Gestiona tu presencia pública en el mapa.",
      "button-1": "Publicar mi negocio",
      "card-2": "Anuncios",
      "text-2": "Publica eventos, ofertas para conectar con la comunidad.",
      "button-2": "Crear publicación",
      "card-3": "Analíticas",
      "text-3": "Descubre cuántas personas ven tu negocio y cómo interactúan contigo",
      "button-3": "Ver estadísticas"
    },
    "profile": {
      "title": "Configuración de usuario",
      "account": "Cuenta",
      "full-name": "Nombre de usuario",
      "user": "usuario",
      "provider": "proveedor",
      "admin": "administrador",
      "email": "Correo electrónico",
      "email-not-changed": "El correo electrónico no se puede cambiar",
      "password": "Contraseña",
      "language": "Idioma",
      "English": "Inglés",
      "Spanish": "Español",
      "French": "Francés",
      "German": "Alemán",
      "location": "Ubicación",
      "default-location": "Ubicación predeterminada",
      "custom-location": "Ubicación personalizada",
      "location-help": "Establece dónde se enfoca el mapa cuando inicias sesión. Puedes escribir una ciudad o hacer clic en el mapa.",
      "location-placeholder": "Establece tu ubicación haciendo clic en el mapa",
      "search-location": "Buscar ciudad, código postal o dirección",
      "find-location": "Buscar",
      "profile-loading": "Cargando perfil...",
      "update-profile": "Actualizar perfil",
      "not-a-member": "¿Aún no eres miembro?",
      "buttons": {
         "update-profile": "Actualizar perfil",
         "loading": "Cargando...",
      },
      "alerts": {
         "profile-update-success": "¡Perfil actualizado con éxito!",
         "profile-update-error": "Error al actualizar el perfil. Por favor, inténtalo de nuevo o contacta con soporte.",
         "profile-access": "Solo puedes editar tu propio perfil.",
         "agree-terms-conditions":"Debes aceptar los términos y condiciones para registrarte.",
         "registration-failed": "Error en el registro. Por favor, inténtalo de nuevo o contacta con soporte.",
         "no-active-listings":"No tienes listados activos. Agregar servicios a tu cuenta.",
         "confirm-delete-listing": "¿Estás seguro de que deseas cancelar este servicio? Se eliminará del mapa.",
         "error-deleting-listing": "Error al eliminar el servicio.",
      },
     "welcome": {
        "access-tools": "Accede a tus herramientas para conectarte con la comunidad local.",
        "already-member": "¿Ya eres miembro?",
        "agree-terms": "Al registrarme, acepto los ",
        "here-to": "Estoy aquí para:",
        "find-services": "Encontrar servicios",
        "offer-services": "Ofrecer servicios",
        "find-services-desc": "Quiero buscar y marcar favoritos.",
        "offer-services-desc": "Quiero listar mis servicios en el mapa y crear eventos.",
        "create-account": "Crear cuenta",
        "register-title": "Únete a somosmas",
        "register-subtitle": "Somos más que un mapa. Somos una comunidad.",
        "create-account-button": "Crear cuenta", 
     },
     "favorites": {
      "welcome": "Bienvenido de nuevo, ",
      "subtitle": "Aquí están tus eventos guardados y proveedores de servicio favoritos.",
      "saved-events": "Eventos guardados",
      "favorite-providers": "Servicios favoritos",
      "my-events": "Mis eventos",
      "favorite-services": "Mis servicios favoritos",
      "browse-events": "Buscar eventos",
      "explore-map": "Explorar mapa",
      "open-route": "Abrir ruta",
      "visit-website": "Visitar sitio web",
      "save-calendar": "Guardar en el calendario",
      "remove-favorite": "Quitar de favoritos",
      "view-details": "Ver detalles",
      "no-events": "Aún no has guardado ningún evento.",
      "find-events": "Buscar eventos",
      "no-places": "Aún no tienes lugares favoritos.",
      "go-to-map": "Ir al mapa",
      "unknown-venue": "Lugar desconocido",
      "alerts": {
        "remove-event": "¿Eliminar este evento de tu panel?",
        "unpin-place": "¿Desanclar este lugar?"
      },
      },
     "service-profile":{
      "title": "Editar perfil del servicio",
      "title-create": "Crear nuevo perfil de servicio",
      "subtitle": "Actualiza cómo aparece tu servicio en el mapa.",
      "subtitle-create": "Añade a tu cuenta un nuevo servicio para mostrar en el mapa.",
      "business-name":"Nombre del servicio",
      "description": "Descripción",
      "refine-location":"Refinar ubicación",
      "website":"Página web",
      "placeholder-email":"e.g. info@negocio.com",
      "placeholder-phone":"e.g. +41 79 123 45 67",
      "placeholder-location": "Introduce la dirección (e.g. Lowenstrasse 10, Zurich) ",
      "preferred-contact":"¿ Cómo te deben contactar los clientes? ",
      "address":"Dirección",
      "latitude":"Latitud",
      "longitude":"Longitud",
      "fine-tune": "O posciona el ratón sobre el mapa para refinar la ubicación.",
      "save-changes": "Guardar cambios",
      "create-service": "Crear servicio",
      "photo": "Foto del servicio",
      "image-hint": "JPG o PNG, máx. 5 MB",
      "alerts":{
        "error-saving-profile": "Error al guardar el perfil.",
        "changes-saved": "Cambios guardados correctamente.",
        "contact-recommended": "Recomendamos añadir al menos un teléfono o email.",
        "error-loading": "Error al cargar los detalles del servicio."
      }
     }
    },
    "general": {
      "install-app": "Instalar somos+ app",
      "apply": "Aplicar",
      "approve": "Aprobar",
      "back": "Atrás",
      "cancel": "Cancelar",
      "close": "Cerrar",
      "confirm": "Confirmar",
      "delete": "Eliminar",
      "edit": "Editar",
      "enter": "Entrar",
      "find": "Buscar",
      "loading": "Cargando...",
      "next": "Siguiente",
      "no": "No",
      "page-not-found": "Página no encontrada",
      "page-not-found-desc": "La página que buscas no existe.",
      "go-home": "Ir al inicio",
      "processing": "Procesando...",
      "reject": "Rechazar",
      "reset": "Restablecer",
      "save": "Guardar",
      "search": "Buscar",
      "searching": "Buscando...",
      "select": "Seleccionar",
      "selected": "Seleccionado",
      "submit": "Enviar",
      "upbdate": "Actualizar",
      "view": "Ver",
      "yes": "Sí",
      "alerts": {
        "registration-success": "¡Acción realizada con éxito! Por favor, revisa tu correo para confirmar tu dirección (revisa la carpeta de spam).",
        "action-success": "¡Acción realizada con éxito!",
        "action-error": "Error al realizar la acción. Por favor, inténtalo de nuevo.",
        "address-not-found": "Dirección no encontrada. Por favor, inténtalo de nuevo.",
        "error-geolocation": "Error al obtener la geolocalización.",
        "save-favourites": "Por favor, inicie su sesión para guardar en favoritos."
      },
      "time":{
        "days":{
          "monday":"Lunes",
          "tuesday":"Martes",
          "wednesday":"Miércoles",
          "thursday":"Jueves",
          "friday":"Viernes",
          "saturday":"Sábado",
          "sunday":"Domingo", 
        },
        "hours":{
          "24-7":"Abierto 24/7",
          "add-hours":"Agregar horario",  
          "alert-monday":"Rellenar horario del lunes primero",
          "alert-confirm-reset":"¿Estás seguro de que deseas restablecer el horario?",
          "business-hours":"Horario comercial",
          "closed":"Cerrado",
          "closes-at":"Cierra a las",
          "copy-monday":"Copiar horario del lunes al resto de días",
          "day":"día",
          "hours":"horas",
          "hours-help":"Establece el horario de apertura y cierre para cada día.",
          "open":"Abre",
          "opens-at":"Abre a las",
          "remove-hours":"Eliminar horario",
          "to":"a",
          "variable-hours":"Horario variable",
        },
      },
      "install-prompt": {
        "title": "Instalar la app",
        "tap": "Toca el",
        "share-then": "icono \"Compartir\" y luego",
        "add-to-home": "\"Añadir a la pantalla de inicio\""
      },
    }
  }
},
de: {
  translation: {
    "nav": {
      "brand-short": "SM",
      "brand": "Somos Mas",
      "map": "Karte",
      "admin": "Admin portal",
      "login": "Anmelden",
      "events": "Veranstaltungen",
      "dashboard": "Dashboard",
      "signout": "Abmelden",
      "register": "Registrieren",
      "profile": "Profil"
    },
    "admin":{
      "provider-manager":{
        "title": "Administratorportal",
      },
      "events": "Veranstaltungen",
      "users": "Benutzer",
      "pending": "Ausstehend",
      "all": "Alle",
      "joined": "Beigetreten",
      "no-results": "Keine Ergebnisse",
      "search-placeholder": "In dieser Liste suchen",
      "view-profile": "Profil anzeigen",
      "unknown-user": "Unbekannter Benutzer",
      "no-name": "Unbekannter Name",
      "providers":{
        "owner-account": "Verknüpftes Konto",
        "community-suggestion": "Community-Vorschlag",
        "suggester-contact": "Kontakt des Vorschlagenden",
        "anonymous-warning": "Anonyme Einreichung — kein registriertes Konto. Kontaktdaten gehören dem Vorschlagenden, nicht einem verifizierten Inhaber. Vor der Genehmigung unabhängig überprüfen.",
      },
      "filter": {
        "pending": "Ausstehend",
        "all": "Alle",
      },
      "tabs": {
        "providers": "Anbieter",
        "events": "Veranstaltungen",
        "users": "Benutzer",
      },
      "status": {
        "approved": "Genehmigt",
        "active": "Aktiv",
        "rejected": "Abgelehnt",
        "live": "Live",
        "past": "Vergangen",
        "pending": "Ausstehend",
        "planned": "Geplant",
        "deleted": "Gelöscht",
      },
      "users":{
        "unverified": "Nicht verifiziert",
        "verified": "Verifiziert",
        "favorites": "Favoriten",
        "events": "Veranstaltungen",
        "business-listings": "Geschäftseinträge",
        "no-listings-found": "Keine Einträge gefunden",
      },
      "alerts":{
        "confirmDeleteUser": "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten? Diese Aktion ist irreversibel!",
        "confirmDeleteEvent": "Sind Sie sicher, dass Sie diese Veranstaltung löschen möchten? Diese Aktion ist irreversibel!",
        "confirmDeleteListing": "Sind Sie sicher, dass Sie diesen Dienst löschen möchten? Diese Aktion ist irreversibel!",
        "confirmRejectListing": "Sind Sie sicher, dass Sie diesen Dienst ablehnen möchten? Diese Aktion ist irreversibel!",
        "confirmRejectEvent": "Sind Sie sicher, dass Sie diese Veranstaltung ablehnen möchten? Diese Aktion ist irreversibel!",
      }
    },
    "common":{
      "we-use": "Wir verwenden unbedingt erforderliche Cookies, ",
      "cookie-text": " um Ihre Anmeldesitzung und Ihre Einstellungen zu verwalten. Durch die weitere Nutzung dieser Website stimmen Sie der Verwendung von Cookies zu.",
      "read-more" : "Weitere Informationen finden Sie in unserer Datenschutzerklärung.",
      "cookie-banner":
        {"acknowledge": "Akzeptieren"}
    },
    "reset-password": {
      "title": "Passwort zurücksetzen",
      "email-placeholder": "Geben Sie Ihre E-Mail ein",
      "submit-button": "Link zum Zurücksetzen senden",
      "update-button": "Passwort aktualisieren",
      "set-new-password": "Neues Passwort festlegen",
      "new-password": "Neues Passwort",
      "update-password-button": "Passwort aktualisieren",
      "alerts":{  
        "reset-link-sent": "Falls die E-Mail existiert, wurde ein Link zum Zurücksetzen gesendet.",
        "reset-link-error": "Fehler beim Senden des Zurücksetzungslinks. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support.",
        "password-update-success": "Passwort erfolgreich aktualisiert! Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
        "password-update-error": "Fehler beim Aktualisieren des Passworts. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
        "invalid-token": "Ungültiges oder abgelaufenes Token. Bitte fordern Sie eine neue Passwortzurücksetzung an.",
        "invalid-credentials": "Ungültige Anmeldeinformationen oder Serverfehler."
      },
      "forgot-password": "Passwort vergessen?",
    },
    "events": {
      "title": "Community-Board",
      "search-button": "Suchen",
      "search-hint": "Enter drücken zum Suchen",
      "hosted-by": "Veranstaltet von",
      "start": "Start",
      "end": "Ende",
      "no-description": "Keine Beschreibung angegeben.",
      "status": { "upcoming": "Bevorstehend" },
      "modal": { "close": "Schließen" },
      "save-event": "Event speichern",
      "unsave-event": "Event entfernen",
      "share": "Teilen",
      "share-event": "Event teilen",
      "link-copied": "Link in die Zwischenablage kopiert!",
      "unknown-host": "Unbekannter Gastgeber",
      "unpin-event": "Event lösen",
      "upload-image": "Bild hochladen",
      "image-hint": "JPG oder PNG, max. 5 MB",
      "choose-file": "Datei auswählen",
      "event-image": "Veranstaltungsbild",
      "featured-events": "Highlights",
      "featuredCarousel": "Empfohlene Veranstaltungen",
      "upcoming-events": "Kommende Veranstaltungen",
      "pageTitle": "Veranstaltungen",
      "subtitle": "Entdecke, was in deiner Gemeinschaft passiert",
      "breadcrumb.home": "Startseite",
      "dateStrip": { "today": "Heute", "tomorrow": "Morgen" },
      "sections": { "thisWeekend": "Dieses Wochenende", "justAnnounced": "Neu angekündigt", "trending": "Im Trend" },
      "showing": "{{count}} Veranstaltungen angezeigt",
      "sort": { "dateAsc": "Datum · Nächste zuerst", "newest": "Neueste", "providerAsc": "Anbieter · A–Z" },
      "viewDetails": "Details ansehen",
      "viewOnMap": "Auf der Karte ansehen",
      "backToTop": "Nach oben",
      "noResultsTitle": "Keine Veranstaltungen zu deinen Filtern gefunden",
      "noResultsBody": "Versuche deine Suche anzupassen oder die Filter zu löschen.",
      "clearFilters": "Filter löschen",
      "event-management":{
        "title": "Event-Verwaltung",
        "no-events-yet": "Noch keine Events",
        "no-events-yet-desc": "Erstelle dein erstes Event mit dem Formular.",
        "create-event": "Event erstellen",
        "active-events": "Aktive Events",
        "past-events": "Vergangene Events",
        "event-title": "Event-Titel",
        "event-title-placeholder": "z.B. Sommerschlussverkauf",
        "event-type": {
          "title": "Kategorie",
          "community": "Gemeinschaft",
          "sale": "Verkauf",
          "food": "Essen",
          "music": "Musik",
          "workshop": "Workshop",
        },
        "alerts": {
          "event-created": "Event erfolgreich erstellt! Administratoren werden es in Kürze überprüfen.",
          "event-creation-failed": "Fehler beim Erstellen des Events. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
          "event-deleted": "Event erfolgreich gelöscht.",
          "event-deletion-failed": "Fehler beim Löschen des Events. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
          "event-sure-delete": "Sind Sie sicher, dass Sie dieses Event löschen möchten? Diese Aktion ist irreversibel.",
        },
        "event-button": "Event veröffentlichen",
        "no-active-events": "Sie haben keine aktiven Events.",
        "no-past-events": "Sie haben keine vergangenen Events.",
        "no-services-found": "Keine Dienste verfügbar.",
        "service": "Dienst",
        "search-by-description": "Nach Beschreibung suchen...",
        "search-by-service-provider": "Nach Dienstanbieter suchen...",
        "log-in-prompt": "Bitte melden Sie sich an, um Ihre Events zu verwalten.",
        "recurrence": {
          "label": "Wiederholung",
          "none": "Keine Wiederholung",
          "weekly": "Wöchentlich",
          "monthly": "Monatlich",
          "end-date": "Wiederholen bis"
        },
        "location": {
          "title": "Ort",
          "use-provider": "Geschäftsadresse verwenden",
          "custom": "Benutzerdefinierter Ort",
          "name": "Veranstaltungsort",
          "address": "Adresse",
          "pick-on-map": "Auf Karte markieren",
          "view-on-map": "Auf Karte anzeigen"
        },
        "description": "Beschreibung"
      },
    },
     "map": {
        "search-address-click-map": "Eine Adresse suchen",
        "click-map-drop-pin": "Setze einen Marker auf die Karte",
        "or": "ODER",
       "add-service": "Dienst vorschlagen",
       "required-fields-notice": "Nur die mit einem Sternchen (*) gekennzeichneten Felder sind Pflichtfelder",
      "add-service-hint": "Lokalen Dienst kennen? Vorschlagen!",
       "business-name":"Dienstname",
       "email":"E-Mail",
       "call":"Anrufen",
       "both":"Beides",
       "phone":"Telefon",
       "step1":"Standort festlegen irgendwo auf der Karte",
       "step1-description": "Klicken Sie irgendwo auf die Karte.",
       "description":"Dienstbeschreibung",
       "contact": "Kontaktinformationen (erforderlich zur Validierung des Dienstes)",
       "contact-required": "Bitte geben Sie mindestens eine E-Mail-Adresse oder Telefonnummer an, damit wir diesen Vorschlag überprüfen können.",
       "preferred-contact":"Bevorzugte Kontaktmethode:",
       "new-location-set":"Neuer Dienst festgelegt! Wir werden uns bald mit Ihnen in Verbindung setzen, um die Daten zu validieren.",
       "edit-service": "Dienst bearbeiten",
       "delete-service": "Dienst löschen",
       "service-form-title": "Dienstdetails",
       "service-name": "Dienstname",
       "service-description": "Beschreibung",
       "service-category": "Kategorie",
       "service-location": "Standort",
       "service-submit": "Absenden",
       "service-cancel": "Abbrechen",
       "service-delete-confirm": "Sind Sie sicher, dass Sie diesen Dienst löschen möchten?",
       "service-no-providers": "Keine Anbieter in diesem Bereich gefunden.",
       "category": "Kategorie",
       "tier": "Stufe",
       "premium": "Premium",
       "basic": "Basisdienst",
       "silver": "Silberstufe",
       "platinum": "Platin-Stufe",
       "submit-request": "Anfrage senden",
       "filters": "Filter",
       "reset-filters": "Filter zurücksetzen",
       "results-singular": "Ergebnis",
        "results-plural":"Ergebnisse",
        "all": "Alle",
        "general": "Allgemein",
       "all-categories": "Alle",
       "general-category": "Allgemein",
       "gastronomy": "Gastronomie",
       "shops": "Geschäfte",
       "health": "Gesundheit",
       "education": "Bildung",
       "services": "Dienstleistungen",
       "welness": "Wellness",
       "welness": "Wellness",
       "technical": "Technisch",
       "culture": "Kultur",
       "active": "Aktiv",
       "expired": "Abgelaufen",
       "pending": "Ausstehend",
       "rejected": "Abgelehnt",
       "business-directory": "Verzeichnis der Dienstleistungen",
       "location-confirmed": "Standort bestätigt",
       "set-your-location": "Standort festlegen *",
       "search-address-click-map": "Eine Adresse suchen oder auf die Karte klicken",
       "enter-address": "Adresse eingeben…",
       "search": "Suchen",
       "click-map-drop-pin": "📍 Klicken Sie irgendwo auf die Karte, um einen Pin zu platzieren",
       "coords": "Koordinaten:",
       "change": "Ändern",
       "website": "Website",
       "website-placeholder": "https://…",
         "phone-placeholder": "Telefonnummer (z.B. +41 …)",
         "email-placeholder": "Öffentliche E-Mail",
         "results-singular": "Ergebnis",
         "results-plural": "Ergebnisse",
         "visit-website": "Website besuchen →",
         "share": "Teilen",
         "link-copied": "Link in die Zwischenablage kopiert!",
         "group-title": "{n} Dienste hier",
         "group-back": "Zurück zur Liste",
         "hours": {
           "open247": "Geöffnet 24/7",
           "variable": "Variable Zeiten",
           "closed": "Geschlossen",
           "open": "Geöffnet",
           "open24h": "24h geöffnet"
         },
         "days": {
           "monday": "Mo",
           "tuesday": "Di",
           "wednesday": "Mi",
           "thursday": "Do",
           "friday": "Fr",
           "saturday": "Sa",
           "sunday": "So"
         }
     },
    "hero": {
        "title": "Angebote, Veranstaltungen und eine Community, um dich zu integrieren und echte Chancen zu schaffen",
        "subtitle": "Vernetzen, entdecken und wachsen in der Schweiz",
        "cta": "Dienste suchen",
        "learn": "Veranstaltungen suchen",
        "suggest": "Dienste vorschlagen",
        "newfeatures":"Sind Sie gerade in der Schweiz angekommen? Brauchen Sie Hilfe?",
        "read": "Mehr lesen",
        "read-less": "Zusammenziehen",
        "small-message": "Mit jeder Nutzung von SOMOS+ leistest du einen direkten Beitrag zu den sozialen Projekten von Proclade Schweiz.",
    },
      "calendar": {
        "next": "Nächste",
        "previous": "Zurück",
        "today": "Heute",
        "month": "Monat",
        "week": "Woche",
        "date": "Datum",
        "time": "Uhrzeit",
        "event": "Veranstaltung",
        "agenda": "Agenda",
        "day": "Tag",
        "noEvents": "Keine Veranstaltungen in diesem Bereich",
      },
    "search": {
      "placeholder": "Dienste, Beschreibungen suchen...",
      "filters": "Filter",
      "showing": "",
      "results": "Ergebnisse",
    },
      "feature": {
        "title": "",
        "short": "Finde Unterstützung, Hilfsangebote und eine Gemeinschaft, um dein Leben in der Schweiz zu beginnen",
        "description": "Erfahren Sie mehr über <historyLink>unsere Geschichte</historyLink> und die Programme, die wir in der Schweiz unterstützen",
        "map-title": "Interaktive Karte",
        "map-description": "Visuelle Lokalisierung aller Dienste mit Echtzeitfiltern und detaillierten Popups.",
        "community-title": "Community-Board",
        "community-description": "Bleiben Sie mit den neuesten Veranstaltungen, Verkäufen und Neuigkeiten Ihrer Lieblingsanbieter auf dem Laufenden.",
        "acoge-title": "Programa ACOGE",
        "acoge-description": "Begleitet dich durch deine ersten Schritte in der Schweiz mit wichtigen Informationen und lokalen Kontakten.",
        "acoge-cta": "Mehr lesen",
        "cuenta-title": "Cuenta Conmigo",
        "cuenta-description": "Erhalte Zugang zu einem Unterstützungsnetzwerk und einem praktischen Leitfaden für dein Leben in der Schweiz.",
        "cuenta-cta": "Leitfaden erkunden",
        "cuenta-manual-supervivencia": "Leitfaden durchsuchen (nur auf Spanisch verfügbar).",
        "cuenta-description2": "Stay updated with the latest events, sales, and news from your favorite providers.",
        "lugar-title": "Un lugar de afuera",
        "lugar-description": "Wahre Geschichten und Gespräche, die dich auf deinem Weg durch den Migrationsprozess begleiten.",
        "lugar-cta": "Mehr lesen",
    },
    "history": {
        "title": "Unsere Geschichte",
        "intro": "SOMOS+ ist ein Projekt von PROCLADE SCHWEIZ, einem Mitglied des internationalen PROCLADE NGO-Netzwerks. Es entstand nicht aus einer Idee, sondern aus einer Erfahrung: Jahre der Arbeit an der Seite der spanischsprachigen Gemeinschaft in der Schweiz, zuhören, begleiten und die Herausforderungen, Bedürfnisse und Hoffnungen der Migrationserfahrung hautnah verstehen.",
        "origins-title": "Unsere Ursprünge",
        "origins-p1": "Unsere Geschichte begann 2016, als eine Gruppe von MCLE-Freiwilligen beschloss, spanischsprachige Einzelpersonen und Familien bei ihren ersten Schritten in der Schweiz zu begleiten, überzeugt davon, dass eine herzliche Aufnahme und rechtzeitige Unterstützung viele der persönlichen, familiären und sozialen Schwierigkeiten verhindern könnte, die oft mit der Migrationserfahrung einhergehen.",
        "origins-p2": "Sehr bald erkannten wir, dass die Menschen über Informationen hinaus etwas noch Wertvolleres brauchten: sich willkommen und orientiert zu fühlen und zu wissen, dass sie nicht allein waren. Aus dieser Erfahrung entstanden Projekte wie das Familienbegleitprogramm, Cuenta Conmigo und Urbamapp (unsere erste geolokalierte Karte), jedes als Antwort auf die echten Bedürfnisse, die wir gemeinsam mit der Gemeinschaft entdeckten.",
        "evolution-title": "Unsere Entwicklung",
        "evolution-p1": "Im Laufe der Jahre erkannten wir, dass ein weiterer Schritt notwendig war. So entstand PROCLADE SCHWEIZ: um all diese Erfahrungen zu bündeln, ihnen Kontinuität zu geben und ihre Wirkung zu verstärken; die in der Schweiz entwickelten Initiativen zu stärken, die internationale Zusammenarbeit des PROCLADE-Netzwerks zu fördern und Selbstfinanzierungsmodelle zu schaffen, die das Wachstum neuer Unterstützungsprogramme wie ACOGE, den Podcast Un lugar de afuera und SOMOS+ ermöglichen.",
        "evolution-p2": "Heute ist SOMOS+ der Ausdruck dieses Weges und dieser Erfahrung. Denn eine Empfehlung kann eine Tür öffnen, eine Orientierung kann Monate der Unsicherheit und mögliche Fehler vermeiden, aber eine vereinte Gemeinschaft kann dafür sorgen, dass sich ein neues Land wie ein Zuhause anfühlt.",
        "invitation-title": "Schreib diese Geschichte mit uns",
        "invitation": "SOMOS+ ist keine fertige Plattform, sondern eine Möglichkeit für jede spanischsprachige Person in der Schweiz, beizutragen, vorzuschlagen und mitzugestalten. Denn die beste Information wird nicht von einer Institution aufgebaut, sondern von Menschen, die ihre Erfahrungen teilen, damit andere den Weg mit mehr Unterstützung gehen können. Ab jetzt schreiben wir diese Geschichte gemeinsam."
    },
    "footer": {
      "description": "Wir verbinden die spanischsprachige Gemeinschaft in der Schweiz mit Dienstleistungen, Möglichkeiten und einem Netzwerk, das dich im Alltag begleitet",
      "platform": "PLATTFORM",
      "map": "Dienstleistungen entdecken",
      "provider": "Einfach anmelden",
      "community": "Veranstaltungen und Community",
      "contact": "UNTERSTÜTZUNG",
      "help": "Hilfe- und Supportcenter",
      "privacy": "Datenschutz-Bestimmungen",
      "terms-of-service": "Nutzungsbedingungen",
      "rights": "Proclade Schweiz. Alle Rechte vorbehalten."
    },
    "alerts": {
      "alert-location-error": "Ihr Standort konnte nicht abgerufen werden.",
      "alert-fetch-error": "Fehler beim Abrufen der Anbieter. Bitte versuchen Sie es später erneut.",
      "alert-submit-success": "Dienst erfolgreich eingereicht!",
      "alert-submit-error": "Fehler beim Einreichen des Dienstes. Bitte versuchen Sie es erneut.",
      "alert-submit-location": "Bitte klicken Sie auf die Karte, um einen Standort auszuwählen.",
      "alert-reset-password-success-message": "Wenn ein Konto mit dieser E-Mail existiert, wurde ein Link zum Zurücksetzen gesendet."
    },
    "buttons": {
      "submit-request": "Anfrage senden",
      "processing": "Verarbeitung...",
      "cancel": "Abbrechen",
      "delete": "Löschen",
      "reset-filters": "Filter zurücksetzen"
    },
      "terms": {
      "terms-and-conditions": "Allgemeine Geschäftsbedingungen (AGB)",
      "updated": "Zuletzt aktualisiert: 13. Februar 2026",
      "introduction": "1. Geltungsbereich",
      "introduction-1": "Diese AGB gelten für die Nutzung der Plattform Somos Mas durch Betreiber, Nutzer und Dienstanbieter.",
      "introduction-2": "",
      "user-accounts": "2. Leistungen",  
      "user-account-cond1": "Somos Mas bietet eine technische Infrastruktur zur Vermittlung von Dienstleistungen und Ereignissen.",
      "user-account-cond2": "",
      "user-account-cond3": "",
      "user-account-cond4": "",
      "service-providers": "3. Vermittlerrolle",
      "service-providers-intro": "Somos Mas ist lediglich Vermittlerin. Verträge kommen ausschliesslich zwischen Nutzern und Dienstanbietern zustande.",
      "service-providers-cond1": "",
      "service-providers-cond2": "",
      "service-providers-cond3": "",
      "service-providers-cond4": "",
      "compliance-header": "4. Verantwortlichkeit für Inhalte",
      "compliance-1": " Dienstanbieter sind allein verantwortlich für die Richtigkeit ihrer Angaben (Preise, Standorte, Bilder). Rechtswidrige Inhalte werden sofort gelöscht.",
      "compliance-2": "",
      "compliance-2-text": "",
      "compliance-3": "",
      "data-protection": "5. Gebühren und Rechnungsstellung",
      "data-protection-1": "",
      "right-to-access": "",
      "right-to-be-forgotten": "",
      "data-portability": "",
      "right-to-access-text": "Die Nutzung für private Nutzer ist kostenlos",
      "right-to-be-forgotten-text": "Für Dienstanbieter können Gebühren (z.B. für Profile oder Premium-Einträge) anfallen.",
      "data-portability-text": "Rechnungen werden elektronisch per E-Mail versandt. Bei Zahlungsverzug kann das Profil gesperrt werden.",
      "further-rights": "",
      "limitation-of-liability": "6. Haftungsbeschränkung",
      "limitation-1": "Die Haftung des Betreibers für Fahrlässigkeit sowie für Schäden durch Dritte wird ausgeschlossen.",
      "dispute-resolutions": "7. Anwendbares Recht & Gerichtsstand",
      "dispute-1": "Es gilt Schweizer Recht. Gerichtsstand ist Zürich, Schweiz.",
      "contact-us": "",
      "contact-1": "Für rechtliche Anfragen oder Support: ",
      "acknowledge": "Durch die Nutzung dieser Website erkennen Sie an, dass Sie diese Bedingungen gelesen und verstanden haben."
    },
    "privacy": {
      "header": {
        "title": "Datenschutz-Bestimmungen",
        "effectiveDate": "Gültig ab: 13. Februar 2026"
      },
      "sections": {
        "intro": {
          "title": "1. Einführung",
          "content": "Wir schützen Ihre personenbezogenen Daten gemäss dem Schweizer Datenschutzgesetz (nDSG) und der EU-DSGVO.",
          "compliance": ""
        },
        "data": {
          "title": "2. Datenerhebung",
          "description": "Wir sammeln Identitätsdaten (Name), Kontaktdaten (E-Mail), technische Daten (IP-Adresse) und Standortdaten (nur mit Ihrer Zustimmung für die Karte).",
        },
        "usage": {
          "title": "3. Nutzung der Daten",
          "description": " Die Daten dienen der Registrierung, der Anzeige von Diensten in Ihrer Nähe und der Sicherheit der Plattform.",
        },
        "cookies": {
          "title": "4. Cookies",
          "body": "Wir verwenden notwendige Cookies für den Login-Bereich. Analyse-Cookies werden nur mit Ihrer Einwilligung gesetzt.",
          "body-2": ""
        },
        "retention": {
          "title": "5. Datenaufbewahrung",
          "body": "Daten werden gelöscht, sobald sie nicht mehr benötigt werden, sofern keine gesetzliche Aufbewahrungspflicht (z.B. 10 Jahre für Rechnungen) besteht.",
          "body-2": ""
        },
        "rights": {
          "title": "6. Ihre Rechte",
          "description": "Sie haben das Recht auf Auskunft, Berichtigung und Löschung Ihrer Daten. (Kontaktieren Sie uns unter: hello@somosmas.ch):",
          "further-rights": "Wenn Sie eines der oben genannten Rechte ausüben möchten, kontaktieren Sie uns bitte."
        },
        "contact": {
          "title": "7. Kontaktinformationen",
          "officer": "Datenschutzbeauftragter:",
          "authority": "Sie haben das Recht, jederzeit eine Beschwerde beim Eidgenössischen Datenschutz- und Öffentlichkeitsbeauftragten (EDÖB) — der schweizerischen Aufsichtsbehörde für Datenschutz — einzureichen über https://www.edoeb.admin.ch oder den EDÖB unter EDÖB, Feldeggweg 1, CH‑3003 Bern zu kontaktieren."
        }
      },
      "footer": {
        "copy": "Datenschutz-Bestimmungen von Somos Mas"
      }
    },
    "landing": {
      "carousel-alt": "Gemeinschaftsfotos",
      "section-heading": "Eine Gemeinschaft. Zwei Chancen.",
      "comunidad-label": "GEMEINSCHAFT",
      "comunidad-heading": "Finden Sie Unterstützung, Dienstleistungen und Möglichkeiten.",
      "comunidad-item-1": "Vertrauenswürdige Fachleute.",
      "comunidad-item-2": "Nahegelegene Unternehmen.",
      "comunidad-item-3": "Veranstaltungen und Aktivitäten.",
      "comunidad-item-4": "Nützliche Informationen für Ihre Integration.",
      "comunidad-cta": "Ich möchte entdecken",
      "proveedores-label": "ANBIETER",
      "proveedores-heading": "Verbinde dich mit Menschen, die brauchen, was du anbietest.",
      "proveedores-item-1": "Mehr Sichtbarkeit.",
      "proveedores-item-2": "Mehr Geschäftsmöglichkeiten.",
      "proveedores-item-3": "Mehr sozialer Einfluss.",
      "proveedores-cta": "Ich möchte mich verbinden",
      "impacto-heading": "Unsere Wirkung",
      "impacto-description": "Mit Ihrer Beteiligung und Unterstützung tragen wir dazu bei, <blue>Chancen</blue>, <blue>Wohlbefinden</blue> und <orange>Hoffnung</orange> für Menschen zu schaffen, die es am meisten brauchen.",
      "impacto-cta-latam": "Entdecken Sie einige unserer Projekte in Lateinamerika",
      "impacto-cta-world": "Entdecken Sie unsere Arbeit auf der ganzen Welt",
      "encuentra-heading": "Finden Sie alles, was Sie suchen, an einem Ort. Kostenlos!",
      "comunidad-modal": {
        "label": "GEMEINSCHAFT",
        "heading": "Treten Sie <highlight>KOSTENLOS</highlight> bei",
        "intro": "Treten Sie SOMOS+ kostenlos bei, der Gemeinschaft, die spanischsprachige Menschen in der Schweiz verbindet, um Dienstleistungen, Möglichkeiten, Informationen und Menschen zu finden, die das Leben fern der Heimat erleichtern.",
        "benefits-heading": "Welche Vorteile erhalten Sie als Nutzer?",
        "benefit-1-title": "Exklusive Vorteile und Aktionen",
        "benefit-1-desc": "Erhalten Sie Rabatte, Aktionen und Sonderleistungen von Unternehmen und Fachleuten, die Teil von SOMOS+ sind.",
        "benefit-2-title": "Kostenlose Kurse und Schulungen",
        "benefit-2-desc": "Nehmen Sie an Workshops, Konferenzen, Mentoring und Schulungsveranstaltungen teil, die von SOMOS+ und seinen Partnern organisiert werden.",
        "benefit-3-title": "Veranstaltungen und Networking",
        "benefit-3-desc": "Erhalten Sie Einladungen zu Treffen, Messen, Kulturveranstaltungen und Events, bei denen Sie Ihr Netzwerk erweitern und neue Möglichkeiten entdecken können.",
        "benefit-4-title": "Vertrauenswürdige Dienstleistungen finden",
        "benefit-4-desc": "Finden Sie einfach Fachleute, Unternehmen und von der Gemeinschaft empfohlene Dienstleistungen.",
        "benefit-5-title": "Favoriten speichern und Anzeigen nach Präferenzen filtern",
        "benefit-5-desc": "Erstellen Sie Ihre eigene Liste von Unternehmen, Dienstleistungen und Fachleuten, um bei Bedarf darauf zuzugreifen, und filtern Sie Ihre Anzeigen.",
        "impact-title": "Ihre Registrierung erzeugt auch eine Wirkung",
        "impact-desc": "Durch die Registrierung bei SOMOS+ tragen Sie auch dazu bei, soziale und humanitäre Initiativen von PROCLADE SCHWEIZ zu fördern und Chancen, Wohlbefinden und Hoffnung in der Schweiz und in verschiedenen Ländern Lateinamerikas zu schaffen.",
        "tagline": "Mehr Vorteile. Mehr Möglichkeiten. Mehr Gemeinschaft.",
        "explore-map": "Karte erkunden",
        "close": "Schließen"
      },
      "proveedores-modal": {
        "label": "ANBIETER",
        "heading": "Willkommen bei",
        "intro-1": "Treten Sie SOMOS+ bei, einem Ökosystem, das Unternehmer, Fachleute und Unternehmen mit der spanischsprachigen Gemeinschaft in der Schweiz verbindet.",
        "intro-2": "Mit einer einzigen Mitgliedschaft steigern Sie die Sichtbarkeit Ihres Unternehmens und tragen gleichzeitig dazu bei, Möglichkeiten, Wohlbefinden und Hoffnung für Menschen zu schaffen, die es am meisten brauchen in Lateinamerika.",
        "benefits-heading": "Was beinhaltet Ihre Mitgliedschaft?",
        "benefits-tagline": "Ihr Unternehmen wächst. Leben werden verändert.",
        "badge-line-1": "Ihr Unternehmen wächst.",
        "badge-line-2": "Leben werden verändert.",
        "benefit-1-title": "Professionelles Profil das ganze Jahr",
        "benefit-1-desc": "Ihr Unternehmen das ganze Jahr über bei SOMOS+ sichtbar.",
        "benefit-2-title": "Veröffentlichung Ihrer Dienstleistungen",
        "benefit-2-desc": "Präsentieren Sie Ihr Unternehmen klar, ansprechend und organisiert.",
        "benefit-3-title": "3 Beiträge pro Jahr",
        "benefit-3-desc": "Enthält 3 Werbebeiträge auf der Plattform.",
        "benefit-4-title": "Social-Media-Promotion",
        "benefit-4-desc": "Wir bewerben Ihr Unternehmen auf Facebook, Instagram und Kanälen.",
        "benefit-5-title": "WhatsApp-Gemeinschaft",
        "benefit-5-desc": "Werden Sie Teil eines aktiven Netzwerks zum Teilen von Neuigkeiten.",
        "benefit-6-title": "Veranstaltungen und Networking",
        "benefit-6-desc": "Zugang zu Messen, Treffen, Schulungen und mehr.",
        "benefit-7-title": "Kundenkontakt",
        "benefit-7-desc": "Interessierte Personen können Sie kontaktieren.",
        "benefit-8-title": "Größere Sichtbarkeit",
        "benefit-8-desc": "Positionieren Sie sich in einem vertrauenswürdigen Ökosystem in Ihrer Sprache.",
        "benefit-9-title": "Ausbildung und Wachstum",
        "benefit-9-desc": "Nehmen Sie an Workshops und Vorträgen teil, um Ihr Unternehmen zu stärken.",
        "benefit-10-title": "Gemeinschaft mit Zweck",
        "benefit-10-desc": "20% fließen in soziale Projekte in Lateinamerika.",
        "price-label": "Ihre Investition",
        "price-period": "CHF / Jahr",
        "price-amount": "360",
        "price-note": "Ungefähr CHF 1 pro Tag.",
        "price-freeze": "Der Wert Ihrer Mitgliedschaft bleibt für 2 Jahre für diejenigen eingefroren, die sich in dieser Phase registrieren.",
        "price-promise": "Keine Erhöhungen. Keine Überraschungen.",
        "impact-heading": "Mehr als eine Mitgliedschaft, eine echte Wirkung",
        "impact-1": "Ihr Unternehmen gewinnt Sichtbarkeit, neue Kunden und mehr Möglichkeiten.",
        "impact-2": "Sie stärken Ihre Positionierung innerhalb der spanischsprachigen Gemeinschaft.",
        "impact-3": "Sie tragen dazu bei, Leben durch soziale Projekte zu verändern.",
        "cta-heading": "Möchten Sie Teil von SOMOS+ werden?",
        "cta-desc": "Schreiben Sie uns und wir begleiten Sie gerne durch den Prozess.",
        "close": "Schließen"
      }
    },
    "provider-analytics": {
      "loading": "Statistiken werden geladen...",
      "title": "Anbieteranalysen",
      "subtitle": "Leistung und Reichweite Ihres Unternehmens",
      "total-favorites": "Gesamte Favoriten",
      "favorites-desc": "Benutzer, die Ihr Profil gespeichert haben",
      "saved-events": "Gespeicherte Veranstaltungen",
      "events-desc": "Interesse an Ihren {{count}} aktiven Veranstaltungen",
      "community-reach": "Gemeinschaftsreichweite",
      "reach-desc": "Gesamte positive Interaktionen",
      "cta-title": "Steigern Sie Ihre Sichtbarkeit!",
      "cta-desc": "Unternehmen, die regelmäßig Veranstaltungen veröffentlichen, werden mit 40 % höherer Wahrscheinlichkeit zu Favoriten hinzugefügt. Veröffentlichen Sie heute etwas Neues!",
      "manage-events": "Meine Veranstaltungen verwalten"
    },
    "provider-dashboard": {
      "title": "Dienstanbieter-Portal",
      "card-1": "Mein Geschäft",
      "text-1": "Verwalten Sie Ihre öffentliche Präsenz auf der Karte.",
      "button-1": "Dienste verwalten",
      "card-2": "Anzeigen",
      "text-2": "Veröffentlichen Sie Veranstaltungen oder Verkäufe für die Gemeinschaft.",
      "button-2": "Ereignisse verwalten",
      "card-3": "Analytik",
      "text-3": "Sehen Sie, wie viele Benutzer auf Ihre Stecknadel geklickt haben.",
      "button-3": "Statistiken anzeigen"
    },
    "profile": {
      "title": "Benutzereinstellungen",
      "account": "Konto",
      "full-name": "Benutzername",
      "user": "Benutzer",
      "provider": "Anbieter",
      "admin": "Administrator",
      "email": "E-Mail",
      "email-not-changed": "Die E-Mail kann nicht geändert werden",
      "password": "Passwort",
      "language": "Sprache",
      "English": "Englisch",
      "Spanish": "Spanisch",
      "French": "Französisch",
      "German": "Deutsch",
      "location": "Standort",
      "default-location": "Standardstandort",
      "custom-location": "Benutzerdefinierter Standort",
      "location-help": "Legen Sie fest, wo die Karte fokussiert wird, wenn Sie sich anmelden. Sie können eine Stadt eingeben oder auf die Karte klicken.",
      "location-placeholder": "Legen Sie Ihren Standort fest, indem Sie auf die Karte klicken",
      "search-location": "Stadt, Postleitzahl oder Adresse suchen",
      "find-location": "Suchen",
      "profile-loading": "Profil wird geladen...",
      "update-profile": "Profil aktualisieren",
      "not-a-member": "Noch kein Mitglied?",
      "buttons": {
          "update-profile": "Profil aktualisieren",
          "loading": "Wird geladen...",
      },
      "alerts": {
          "profile-update-success": "Profil erfolgreich aktualisiert!",
          "profile-update-error": "Fehler beim Aktualisieren des Profils. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
          "profile-access": "Sie können nur Ihr eigenes Profil bearbeiten.",
          "agree-terms-conditions":"Sie müssen den Allgemeinen Geschäftsbedingungen zustimmen, um sich zu registrieren.",
          "registration-failed": "Registrierungsfehler. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
          "no-active-listings":"Sie haben keine aktiven Einträge. Fügen Sie Ihrer Konto Dienste hinzu.",
          "confirm-delete-listing": "Möchten Sie dieses Angebot wirklich kündigen? Es wird von der Karte entfernt.",
          "error-deleting-listing": "Fehler beim Löschen des Serviceangebots.",
      },
     "welcome": {
        "access-tools": "Greifen Sie auf Ihre Tools zu, um sich mit der lokalen Gemeinschaft zu verbinden.",
        "already-member": "Bereits Mitglied?",
        "agree-terms": "Indem ich mich anmelde, stimme ich den ",
        "here-to": "Ich bin hier, um:",
        "find-services": "Dienstleistungen zu finden",
        "offer-services": "Dienstleistungen anzubieten",
        "find-services-desc": "Ich möchte suchen und Favoriten markieren.",
        "offer-services-desc": "Ich möchte meine Dienstleistungen auf der Karte auflisten und Veranstaltungen erstellen.",
        "create-account": "Konto erstellen",
        "register-title": "Treten Sie somosmas bei",
        "register-subtitle": "Wir sind mehr als eine Karte. Wir sind eine Gemeinschaft.",
        "create-account-button": "Konto erstellen",
     },
     "favorites": {
        "welcome": "Willkommen zurück, ",
        "subtitle": "Hier sind deine gespeicherten Veranstaltungen und bevorzugten Dienstanbieter.",
        "saved-events": "Gespeicherte Veranstaltungen",
        "favorite-providers": "Bevorzugte Dienste",
        "my-events": "Meine Veranstaltungen",
        "favorite-services": "Meine bevorzugten Dienste",
        "browse-events": "Veranstaltungen durchsuchen",
        "explore-map": "Karte erkunden",
        "open-route": "Route öffnen",
        "visit-website": "Webseite besuchen",
        "save-calendar": "In Kalender speichern",
        "remove-favorite": "Aus Favoriten entfernen",
        "view-details": "Details ansehen",
        "no-events": "Sie haben noch keine Veranstaltungen gespeichert.",
        "find-events": "Veranstaltungen finden",
        "no-places": "Noch keine Lieblingsorte.",
        "go-to-map": "Zur Karte",
        "unknown-venue": "Unbekannter Veranstaltungsort",
        "alerts": {
          "remove-event": "Diese Veranstaltung von Ihrem Dashboard entfernen?",
          "unpin-place": "Diesen Ort lösen?"
        },
        },
     "service-profile":{
      "title": "Dienstprofil bearbeiten",
      "title-create": "Neues Dienstprofil erstellen",
      "subtitle": "Aktualisiere, wie dein Dienst auf der Karte angezeigt wird.",
      "subtitle-create": "Füge deinem Konto einen neuen Dienst hinzu, der auf der Karte angezeigt wird.",
      "business-name":"Name des Dienstes",
      "description": "Beschreibung",
      "refine-location":"Standort verfeinern",
      "website":"Webseite",
      "placeholder-email":"z. B. info@unternehmen.com",
      "placeholder-phone":"z. B. +41 79 123 45 67",
      "placeholder-location": "Gib die Adresse ein (z. B. Löwenstrasse 10, Zürich)",
      "preferred-contact":"Wie sollen Kunden dich kontaktieren?",
      "address":"Adresse",
      "latitude":"Breitengrad",
      "longitude":"Längengrad",
      "fine-tune": "Oder positioniere die Maus auf der Karte, um den Standort zu verfeinern.",
      "save-changes": "Änderungen speichern",
      "create-service": "Dienst erstellen",
      "photo": "Dienstfoto",
      "image-hint": "JPG oder PNG, max. 5 MB",
      "alerts":{
        "error-saving-profile": "Fehler beim Speichern des Profils.",
        "changes-saved": "Änderungen erfolgreich gespeichert.",
        "contact-recommended": "Wir empfehlen, mindestens eine Telefonnummer oder E-Mail hinzuzufügen.",
        "error-loading": "Fehler beim Laden der Dienstdetails."
        }
     }
    },
    "general":{
      "install-app": "Installieren somos+ app",
      "apply": "Anwenden",
      "approve": "Genehmigen",
      "back": "Zurück",
      "cancel": "Abbrechen",
      "close": "Schließen",
      "confirm": "Bestätigen",
      "delete": "Löschen",
      "page-not-found": "Seite nicht gefunden",
      "page-not-found-desc": "Die gesuchte Seite existiert nicht.",
      "go-home": "Zur Startseite",
      "edit": "Bearbeiten",
      "enter": "Eingeben",
      "find": "Suchen",
      "loading": "Wird geladen...",
      "next": "Weiter",
      "no": "Nein",
      "processing": "Verarbeitung...",
      "reject": "Ablehnen",
      "reset": "Zurücksetzen",
      "save": "Speichern",
      "search": "Suchen",
      "select": "Auswählen",
      "selected": "Ausgewählt",
      "submit": "Absenden",
      "update": "Aktualisieren",
      "searching": "Suche...",
      "view": "Ansehen",
      "yes": "Ja",
      "alerts":{
        "registration-success": "Vorgang erfolgreich abgeschlossen! Bitte überprüfe deine E-Mails, um deine Adresse zu bestätigen (schau auch im Spam-Ordner nach).",
        "action-success": "Aktion erfolgreich durchgeführt.",
        "action-error": "Fehler beim Ausführen der Aktion. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support." ,
        "address-not-found": "Adresse nicht gefunden. Bitte versuchen Sie es erneut.",
        "error-geocoding": "Fehler bei der Geokodierung der Adresse. Bitte versuchen Sie es erneut.",
        "save-favourites": "Bitte melden Sie sich an, um Favoriten zu speichern.",
        "error-geolocation": "Ihr Standort konnte nicht abgerufen werden.",
      },
      "time":{
        "days":{
          "monday": "Montag",
          "tuesday": "Dienstag",
          "wednesday": "Mittwoch",
          "thursday": "Donnerstag",
          "friday": "Freitag",
          "saturday": "Samstag",
          "sunday": "Sonntag"
        },
        "hours":{
          "24-7": "24/7",
          "add-hours": "Öffnungszeiten hinzufügen",
          "alert-monday": "Montag Offnungszeiten erst erstellen",
          "alert-confirm-reset": "Möchten Sie die Öffnungszeiten wirklich zurücksetzen?",
          "business-hours": "Öffnungszeiten",
          "closed": "Geschlossen",
          "closes-at": "Schließt um",
          "copy-monday": "Montag kopieren",
          "day": "Tag",
          "hours": "Stunden",
          "hours-help": "Legen Sie die Öffnungszeiten für jeden Tag fest. Sie können mehrere Zeitfenster pro Tag hinzufügen.",
          "open": "Geöffnet",
          "opens-at": "Öffnet um",
          "remove-hours": "Öffnungszeiten entfernen",
          "to": "bis",
          "variable-hours": "Variable Öffnungszeiten",
        }
      },
      "install-prompt": {
        "title": "App installieren",
        "tap": "Tippen Sie auf",
        "share-then": "das Symbol \"Teilen\" und dann",
        "add-to-home": "\"Zum Home-Bildschirm hinzufügen\""
      },
    }
  }
},
fr: {
  translation: {
    "nav": {
      "brand-short": "SM",
      "brand": "Somos Mas",
      "map": "Carte",
      "admin": "Portail admin",
      "login": "Connexion",
      "events": "Événements",
      "dashboard": "Tableau de bord",
      "signout": "Déconnexion",
      "register": "S'inscrire",
      "profile": "Profil"
    },  
    "admin":{
      "provider-manager":{
        "title": "Portail administrateur",
      },
      "events": "Événements",
      "users": "Utilisateurs",
      "pending": "En attente",
      "all": "Tout",
      "joined": "Inscrit",
      "no-results": "Aucun résultat",
      "search-placeholder": "Rechercher dans cette liste",
      "view-profile": "Voir le profil",
      "unknown-user": "Utilisateur inconnu",
      "no-name": "Nom inconnu",
      "providers":{
        "owner-account": "Compte associé",
        "community-suggestion": "Suggestion communautaire",
        "suggester-contact": "Contact du suggesteur",
        "anonymous-warning": "Soumission anonyme — aucun compte enregistré. Les coordonnées appartiennent à l'auteur de la suggestion, pas à un propriétaire vérifié. Vérifiez indépendamment avant d'approuver.",
      },
      "filter": {
        "pending": "En attente",
        "all": "Tous",
      },
      "tabs": {
        "providers": "Fournisseurs",
        "events": "Événements",
        "users": "Utilisateurs",
      },
      "status": {
        "approved": "Approuvé",
        "active": "Actif",
        "rejected": "Rejeté",
        "live": "En direct",
        "past": "Passé",
        "pending": "En attente",
        "planned": "Planifié",
        "deleted": "Supprimé",
      },
      "users":{
        "unverified": "Non vérifié",
        "verified": "Validé",
        "favorites": "Favoris",
        "events": "Événements",
        "business-listings": "Annonces professionnelles",
        "no-listings-found": "Aucune annonce trouvée",
      },
      "alerts":{
        "confirmDeleteUser": "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible !",
        "confirmDeleteEvent": "Êtes-vous sûr de vouloir supprimer cet événement ? Cette action est irréversible !",
        "confirmDeleteListing": "Êtes-vous sûr de vouloir supprimer ce service ? Cette action est irréversible !",
        "confirmRejectListing": "Êtes-vous sûr de vouloir rejeter ce service ? Cette action est irréversible !",
        "confirmRejectEvent": "Êtes-vous sûr de vouloir rejeter cet événement ? Cette action est irréversible !",
      }
    },
    "common":{
      "we-use": "Nous utilisons des cookies strictement nécessaires ",
      "cookie-text": " pour gérer votre session de connexion et vos préférences cartographiques. En continuant à utiliser ce site, vous acceptez notre utilisation des cookies.",
      "read-more" : "En savoir plus sur notre politique de confidentialité.",
      "cookie-banner":
      {"acknowledge": "Accepter"}
    },
    "reset-password": {
      "title": "Réinitialiser le mot de passe",
      "email-placeholder": "Entrez votre email",
      "submit-button": "Envoyer le lien de réinitialisation",
      "update-button": "Mettre à jour le mot de passe",
      "set-new-password": "Définir un nouveau mot de passe",
      "new-password": "Nouveau mot de passe",
      "update-password-button": "Mettre à jour le mot de passe",
      "alerts":{
        "reset-link-sent": "Si l'email existe, un lien de réinitialisation a été envoyé.",
        "reset-link-error": "Erreur lors de l'envoi du lien de réinitialisation. Veuillez réessayer plus tard ou contacter le support.",
        "password-update-success": "Mot de passe mis à jour avec succès ! Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
        "password-update-error": "Erreur lors de la mise à jour du mot de passe. Veuillez réessayer ou contacter le support.",
        "invalid-token": "Jeton invalide ou expiré. Veuillez demander une nouvelle réinitialisation de mot de passe.",
        "invalid-credentials": "Identifiants invalides ou erreur du serveur."
      },
      "forgot-password": "Mot de passe oublié?",
    },
    "map": {
      "search-address-click-map": "Rechercher une adresse",
      "click-map-drop-pin": "Place un marqueur sur la carte",
      "or": "OU",
      "add-service": "Proposer un service",
       "required-fields-notice": "Seuls les champs marqués d'un astérisque (*) sont obligatoires",
     "add-service-hint": "Un service local manque ? Suggérez-le !",
      "business-name":"Nom du service",
      "email":"Email",
      "call":"Appeler",
      "both":"Les deux",
      "phone":"Téléphone",
      "step1":"Définir l'emplacement quelque part sur la carte",
      "step1-description": "Cliquez n'importe où sur la carte.",
      "description":"Description du service",
      "contact": "Informations de contact (nécessaires pour valider le service)",
      "contact-required": "Veuillez fournir au moins un e-mail ou un numéro de téléphone pour vérifier cette suggestion.",
      "preferred-contact":"Méthode de contact préférée :",
      "new-location-set":"Nouveau service défini ! Nous vous contacterons bientôt pour valider les données.",
      "edit-service": "Modifier le service",
      "delete-service": "Supprimer le service",
      "service-form-title": "Détails du service",
      "service-name": "Nom du service",
      "service-description": "Description",
      "service-category": "Catégorie",
      "service-location": "Emplacement",
      "service-submit": "Soumettre",
      "service-cancel": "Annuler",
      "service-delete-confirm": "Êtes-vous sûr de vouloir supprimer ce service ?",
      "service-no-providers": "Aucun fournisseur trouvé dans cette zone.",
      "category": "Catégorie",
      "tier": "Niveau",
      "premium": "Premium",
      "basic": "Service de base",
      "silver": "Niveau Argent",
      "platinum": "Niveau Platine",
      "submit-request": "Soumettre la demande",
      "filters": "Filtres",
      "reset-filters": "Réinitialiser les filtres",
      "results-singular": "résultat",
       "results-plural":"résultats",
      "all": "Toutes",
      "general": "Général",
      "all-categories": "Toutes",
      "general-category": "Général",
      "gastronomy": "Gastronomie",
      "shops": "Commerces",
      "health": "Santé",
      "education": "Éducation",
      "services": "Services",
      "welness": "Bien-être",
      "wellness": "Bien-être",
      "technical": "Technique",
      "culture": "Culture",
      "active": "Actif",
      "expired": "Expiré",
      "pending": "En attente",
      "rejected": "Rejeté",
      "business-directory": "Répertoire des services",
      "visit-website": "Visiter le site →",
      "share": "Partager",
      "link-copied": "Lien copié dans le presse-papiers !",
      "group-title": "{n} services ici",
      "group-back": "Retour à la liste",
      "hours": {
        "open247": "Ouvert 24h/24",
        "variable": "Horaires variables",
        "closed": "Fermé",
        "open": "Ouvert",
        "open24h": "Ouvert 24h"
      },
      "days": {
        "monday": "Lun",
        "tuesday": "Mar",
        "wednesday": "Mer",
        "thursday": "Jeu",
        "friday": "Ven",
        "saturday": "Sam",
        "sunday": "Dim"
      }
    },
    "hero": {
        "title": "Des services, des événements et une communauté pour t'aider à t'intégrer et à créer de réelles opportunités",
        "subtitle": "Entrez en contact, faites des rencontres et développez-vous en Suisse",
        "cta": "Chercher des services",
        "learn": "Chercher des événements",
        "suggest": "Suggérer des services",
        "newfeatures":"Vous venez d'arriver en Suisse ? Vous avez besoin d'aide ?",
        "read": "Lire la suite",
        "read-less": "Réduire",
        "small-message": "À chaque fois que vous utilisez SOMOS+, vous contribuez directement aux projets sociaux de Proclade Schweiz.",
    },
    "events": {
      "title": "Tableau communautaire",
      "search-button": "Rechercher",
      "search-hint": "Appuyez sur Entrée pour rechercher",
      "hosted-by": "Organisé par",
      "start": "Début",
      "end": "Fin",
      "no-description": "Aucune description fournie.",
      "status": { "upcoming": "À venir" },
      "modal": { "close": "Fermer" },
      "save-event": "Enregistrer l'événement",
      "unsave-event": "Retirer l'événement",
      "share": "Partager",
      "share-event": "Partager l'événement",
      "link-copied": "Lien copié dans le presse-papiers !",
      "unknown-host": "Hôte inconnu",
      "unpin-event": "Détacher l'événement",
      "pin-event": "Épingler l'événement",
      "upload-image": "Télécharger une image",
      "image-hint": "JPG ou PNG, max 5 Mo",
      "choose-file": "Choisir un fichier",
      "event-image": "Image de l'événement",
      "featured-events": "Événements phares",
      "featuredCarousel": "Événements en vedette",
      "upcoming-events": "Prochains événements",
      "pageTitle": "Événements",
      "subtitle": "Découvrez ce qui se passe dans votre communauté",
      "breadcrumb.home": "Accueil",
      "dateStrip": { "today": "Aujourd'hui", "tomorrow": "Demain" },
      "sections": { "thisWeekend": "Ce week-end", "justAnnounced": "Récemment publiés", "trending": "Tendances" },
      "showing": "{{count}} événements affichés",
      "sort": { "dateAsc": "Date · Plus proches", "newest": "Plus récents", "providerAsc": "Prestataire · A–Z" },
      "viewDetails": "Voir les détails",
      "viewOnMap": "Voir sur la carte",
      "backToTop": "Retour en haut",
      "noResultsTitle": "Aucun événement ne correspond à vos filtres",
      "noResultsBody": "Essayez d'ajuster votre recherche ou de supprimer les filtres.",
      "clearFilters": "Effacer les filtres",
      "event-management":{
        "title": "Gestion des événements",
        "no-events-yet": "Aucun événement",
        "no-events-yet-desc": "Créez votre premier événement via le formulaire.",
        "create-event": "Créer un événement",
        "active-events": "Événements actifs",
        "past-events": "Événements passés",
        "event-title": "Titre de l'événement",
        "event-title-placeholder": "Ex : Soldes d'été",
        "event-type": {
          "title": "Catégorie",
          "community": "Communauté",
          "sale": "Vente",
          "food": "Nourriture",
          "music": "Musique",
          "workshop": "Atelier",
        },
        "alerts": {
          "event-created": "Événement créé avec succès ! Les administrateurs le vérifieront sous peu.",
          "event-creation-failed": "Erreur lors de la création de l'événement. Veuillez réessayer ou contacter le support.",
          "event-deleted": "Événement supprimé avec succès.",
          "event-deletion-failed": "Erreur lors de la suppression de l'événement. Veuillez réessayer ou contacter le support.",
          "event-sure-delete": "Êtes-vous sûr de vouloir supprimer cet événement ? Cette action est irréversible.",
        },
        "event-button": "Publier l'événement",
        "no-active-events": "Vous n'avez pas d'événements actifs.",
        "no-past-events": "Vous n'avez pas d'événements passés.",
        "no-services-found": "Aucun service disponible.",
        "service": "Service",
        "search-by-description": "Rechercher par description...",
        "search-by-service-provider": "Rechercher par fournisseur de services...",
        "log-in-prompt": "Veuillez vous connecter pour gérer vos événements.",
        "recurrence": {
          "label": "Répétition",
          "none": "Sans répétition",
          "weekly": "Hebdomadaire",
          "monthly": "Mensuel",
          "end-date": "Répéter jusqu'au"
        },
        "location": {
          "title": "Lieu",
          "use-provider": "Utiliser l'adresse du service",
          "custom": "Lieu personnalisé",
          "name": "Nom du lieu",
          "address": "Adresse",
          "pick-on-map": "Épingler sur la carte",
          "view-on-map": "Voir sur la carte"
        },
        "description": "Description"
      },
    },
    "calendar": {
        "next": "Suivant",
        "previous": "Précédent",
        "today": "Aujourd'hui",
        "month": "Mois",
        "week": "Semaine",
        "date": "Date",
        "time": "Heure",
        "event": "Événement",
        "agenda": "Agenda",
        "day": "Jour",
        "noEvents": "Aucun événement dans cette plage",
      },
    "search": {
       "placeholder": "Rechercher des services, des descriptions...",
       "filters": "Filtres",
       "showing": "Affichage",
       "results": "résultats"
    },
      "feature": {
        "title": "",
        "short": "Tout ce dont vous avez besoin pour trouver des solutions près de chez vous",
        "description": "Découvrez-en davantage sur <historyLink>notre histoire</historyLink> et les programmes que nous soutenons en Suisse",
        "acoge-title": "Programa ACOGE",
        "acoge-description": "Nous vous guidons dans vos premiers pas en Suisse avec des informations clés et des connexions aux services locaux.",
        "acoge-cta": "Lire plus",
        "cuenta-title": "Cuenta Conmigo",
        "cuenta-description": "Accédez à un réseau de soutien et à un guide pratique avec l'essentiel pour votre vie en Suisse.",
        "cuenta-cta": "Explorer le guide",
        "cuenta-manual-supervivencia": "guide de survie en Suisse (disponible uniquement en espagnol).",
        "cuenta-description2": "Stay updated with the latest events, sales, and news from your favorite providers.",
        "lugar-title": "Un lugar de afuera",
        "lugar-description": "Histoires réelles et conversations qui vous accompagnent tout au long de votre parcours migratoire.",
        "lugar-cta": "Lire plus",
    },
    "history": {
        "title": "Notre Histoire",
        "intro": "SOMOS+ est un projet de PROCLADE SCHWEIZ, membre du réseau international PROCLADE ONG. Il n'est pas né d'une idée, mais d'une expérience : des années de travail aux côtés de la communauté hispanophone en Suisse, à écouter, accompagner et comprendre de près les défis, les besoins et les espoirs qui font partie de l'expérience migratoire.",
        "origins-title": "Nos Origines",
        "origins-p1": "Notre histoire a commencé en 2016, lorsqu'un groupe de bénévoles de la MCLE a décidé d'accompagner des personnes et des familles hispanophones dans leurs premiers pas en Suisse, convaincus qu'un accueil chaleureux et un soutien opportun pouvaient prévenir de nombreuses difficultés personnelles, familiales et sociales qui accompagnent souvent l'expérience migratoire.",
        "origins-p2": "Très vite, nous avons compris que, au-delà des informations, les gens avaient besoin de quelque chose d'encore plus précieux : se sentir accueillis, guidés et savoir qu'ils n'étaient pas seuls. De cette expérience sont nés des projets comme le Programme d'accompagnement familial, Cuenta Conmigo et Urbamapp (notre première carte géolocalisée), chacun créé en réponse aux besoins réels que nous découvrions avec la communauté elle-même.",
        "evolution-title": "Notre Évolution",
        "evolution-p1": "Au fil des années, nous avons compris qu'une nouvelle étape était nécessaire. C'est ainsi qu'est née PROCLADE SCHWEIZ : pour rassembler toute cette expérience, lui donner une continuité et amplifier son impact ; renforcer les initiatives développées en Suisse, promouvoir la coopération internationale du réseau PROCLADE et créer des modèles d'autofinancement qui permettraient la croissance de nouveaux programmes de soutien comme ACOGE, le podcast Un lugar de afuera et SOMOS+.",
        "evolution-p2": "Aujourd'hui, SOMOS+ est l'expression de ce parcours et de cette expérience. Car une recommandation peut ouvrir une porte, une orientation peut éviter des mois d'incertitude et d'erreurs possibles, mais une communauté unie peut faire qu'un nouveau pays se sente comme un foyer.",
        "invitation-title": "Écris cette histoire avec nous",
        "invitation": "SOMOS+ n'est pas une plateforme terminée, mais une opportunité pour chaque personne hispanophone vivant en Suisse de contribuer, suggérer et proposer. Car la meilleure information n'est pas construite par une institution, mais par des personnes qui partagent leur expérience pour que d'autres puissent parcourir le chemin avec plus de soutien. À partir de maintenant, cette histoire est écrite par nous tous."
    },
    "footer": {
      "description": "Nous mettons en relation la communauté hispanophone de Suisse avec des services, des opportunités et un réseau qui vous accompagne au quotidien",
      "platform": "PLATEFORME",
      "map": "Découvrir les services",
      "provider": "Portail d'accès",
      "community": "Événements",
      "contact": "SUPPORT",
      "help": "Centre d'aide",
      "privacy": "Politique de confidentialité",
      "terms-of-service": "Conditions d'utilisation",
      "rights": "Proclade Schweiz. Tous droits réservés."
    },
    "alerts": {
      "alert-location-error": "Impossible de récupérer votre position.",
      "alert-fetch-error": "Erreur lors de la récupération des fournisseurs. Veuillez réessayer plus tard.",
      "alert-submit-success": "Service soumis avec succès !",
      "alert-submit-error": "Erreur lors de la soumission du service. Veuillez réessayer.",
      "alert-submit-location": "Veuillez cliquer sur la carte pour sélectionner un emplacement.",
      "alert-reset-password-success-message": "Si un compte avec cet e-mail existe, un lien de réinitialisation a été envoyé."
    },
    "buttons": {
      "submit-request": "Soumettre la demande",
      "processing": "Traitement...",
      "cancel": "Annuler",
      "delete": "Supprimer",
      "reset-filters": "Réinitialiser les filtres"
    },
   "terms": {
  "terms-and-conditions": "Conditions Générales de Vente (CGV)",
  "updated": "Dernière mise à jour : 13 février 2026",
  "introduction": "1. Champ d'application",
  "introduction-1": "Ces CGV s'appliquent à l'utilisation de la plateforme Somos Más par les exploitants, les utilisateurs et les prestataires de services.",
  "introduction-2": "",
  "user-accounts": "2. Prestations",
  "user-account-cond1": "Somos Más fournit une infrastructure technique pour la mise en relation de services et d'événements.",
  "user-account-cond2": "",
  "user-account-cond3": "",
  "user-account-cond4": "",
  "service-providers": "3. Rôle d'intermédiaire",
  "service-providers-intro": "Somos Más n'est qu'un intermédiaire. Les contrats sont conclus exclusivement entre les utilisateurs et les prestataires de services.",
  "service-providers-cond1": "",
  "service-providers-cond2": "",
  "service-providers-cond3": "",
  "service-providers-cond4": "",
  "compliance-header": "4. Responsabilité du contenu",
  "compliance-1": "Les prestataires de services sont seuls responsables de l'exactitude de leurs informations (prix, lieux, images). Les contenus illicites seront immédiatement supprimés.",
  "compliance-2": "",
  "compliance-2-text": "",
  "compliance-3": "",
  "data-protection": "5. Frais et Facturation",
  "data-protection-1": "",
  "right-to-access": "",
  "right-to-be-forgotten": "",
  "data-portability": "",
  "right-to-access-text": "L'utilisation pour les utilisateurs privés est gratuite.",
  "right-to-be-forgotten-text": "Des frais peuvent s'appliquer aux prestataires de services (par exemple pour les profils ou les inscriptions premium).",
  "data-portability-text": "Les factures sont envoyées par voie électronique par e-mail. En cas de retard de paiement, le profil peut être suspendu.",
  "further-rights": "",
  "limitation-of-liability": "6. Limitation de responsabilité",
  "limitation-1": "La responsabilité de l'exploitant pour négligence ainsi que pour les dommages causés par des tiers est exclue.",
  "dispute-resolutions": "7. Droit applicable et Forum",
  "dispute-1": "Le droit suisse est applicable. Le for juridique est Zurich, Suisse.",
  "contact-us": "",
  "contact-1": "Pour les demandes juridiques ou le support : ",
  "acknowledge": "En utilisant ce site web, vous reconnaissez avoir lu et compris ces conditions."
},
    "privacy": {
  "header": {
    "title": "Politique de Confidentialité",
    "effectiveDate": "Valable à partir du : 13 février 2026"
  },
  "sections": {
    "intro": {
      "title": "1. Introduction",
      "content": "Nous protégeons vos données personnelles conformément à la Loi suisse sur la protection des données (nLPD) et au RGPD de l'UE.",
      "compliance": ""
    },
    "data": {
      "title": "2. Collecte de données",
      "description": "Nous collectons des données d'identité (nom), des données de contact (e-mail), des données techniques (adresse IP) et des données de localisation (uniquement avec votre consentement pour la carte)."
    },
    "usage": {
      "title": "3. Utilisation des données",
      "description": "Les données sont utilisées pour l'inscription, l'affichage des services à proximité et la sécurité de la plateforme."
    },
    "cookies": {
      "title": "4. Cookies",
      "body": "Nous utilisons des cookies nécessaires pour l'espace de connexion. Les cookies d'analyse ne sont déposés qu'avec votre consentement.",
      "body-2": ""
    },
    "retention": {
      "title": "5. Conservation des données",
      "body": "Les données sont supprimées dès qu'elles ne sont plus nécessaires, à moins qu'il n'existe une obligation légale de conservation (par exemple, 10 ans pour les factures).",
      "body-2": ""
    },
    "rights": {
      "title": "6. Vos droits",
      "description": "Vous avez un droit d'accès, de rectification et de suppression de vos données. (Contactez-nous à : hello@somosmas.ch) :",
      "further-rights": "Si vous souhaitez exercer l'un des droits mentionnés ci-dessus, veuillez nous contacter."
    },
    "contact": {
      "title": "7. Informations de contact",
      "officer": "Délégué à la protection des données :",
      "authority": "Vous avez le droit de déposer une plainte à tout moment auprès du Préposé fédéral à la protection des données et à la transparence (PFPDT) — l'autorité de surveillance suisse pour la protection des données — via https://www.edoeb.admin.ch ou en contactant le PFPDT à l'adresse PFPDT, Feldeggweg 1, CH-3003 Berne."
    }
  },
  "footer": {
    "copy": "Politique de Confidentialité de Somos Más"
  }
},
    
  "landing": {
      "carousel-alt": "Photos de la communauté",
      "section-heading": "Une communauté. Deux opportunités.",
      "comunidad-label": "COMMUNAUTÉ",
      "comunidad-heading": "Trouvez du soutien, des services et des opportunités.",
      "comunidad-item-1": "Professionnels de confiance.",
      "comunidad-item-2": "Entreprises à proximité.",
      "comunidad-item-3": "Événements et activités.",
      "comunidad-item-4": "Informations utiles pour votre intégration.",
      "comunidad-cta": "Je veux découvrir",
      "proveedores-label": "FOURNISSEURS",
      "proveedores-heading": "Connectez-vous avec des personnes qui ont besoin de ce que vous offrez.",
      "proveedores-item-1": "Plus de visibilité.",
      "proveedores-item-2": "Plus d'opportunités commerciales.",
      "proveedores-item-3": "Plus d'impact social.",
      "proveedores-cta": "Je veux me connecter",
      "impacto-heading": "Notre Impact",
      "impacto-description": "Avec votre participation et votre soutien, nous contribuons à créer des <blue>opportunités</blue>, du <blue>bien-être</blue> et de l'<orange>espoir</orange> pour ceux qui en ont le plus besoin.",
      "impacto-cta-latam": "Découvrez certains de nos projets en Amérique latine",
      "impacto-cta-world": "Découvrez notre travail dans le monde",
      "encuentra-heading": "Trouvez tout ce que vous cherchez en un seul endroit. Gratuit !",
      "comunidad-modal": {
        "label": "COMMUNAUTÉ",
        "heading": "Rejoignez <highlight>GRATUITEMENT</highlight>",
        "intro": "Rejoignez SOMOS+ gratuitement, la communauté qui connecte les hispanophones en Suisse pour trouver des services, des opportunités, des informations et des personnes qui facilitent la vie loin de chez soi.",
        "benefits-heading": "Quels avantages obtenez-vous en tant qu'utilisateur ?",
        "benefit-1-title": "Avantages et promotions exclusifs",
        "benefit-1-desc": "Accédez aux remises, promotions et avantages spéciaux offerts par les entreprises et professionnels faisant partie de SOMOS+.",
        "benefit-2-title": "Cours et formations gratuits",
        "benefit-2-desc": "Participez à des ateliers, conférences, mentorats et espaces de formation organisés par SOMOS+ et ses partenaires.",
        "benefit-3-title": "Événements et réseautage",
        "benefit-3-desc": "Recevez des invitations à des rencontres, foires, activités culturelles et événements où vous pourrez élargir votre réseau et découvrir de nouvelles opportunités.",
        "benefit-4-title": "Trouvez des services de confiance",
        "benefit-4-desc": "Localisez facilement des professionnels, des entreprises et des services recommandés par la communauté.",
        "benefit-5-title": "Sauvegardez vos favoris et filtrez les annonces par préférences",
        "benefit-5-desc": "Créez votre propre liste d'entreprises, de services et de professionnels pour y accéder en cas de besoin et filtrez vos annonces et publications.",
        "impact-title": "Votre inscription génère également un impact",
        "impact-desc": "En vous inscrivant à SOMOS+, vous contribuez également à soutenir des initiatives sociales et humanitaires promues par PROCLADE SCHWEIZ, générant des opportunités, du bien-être et de l'espoir en Suisse et dans divers pays d'Amérique latine.",
        "tagline": "Plus d'avantages. Plus d'opportunités. Plus de communauté.",
        "explore-map": "Explorer la carte",
        "close": "Fermer"
      },
      "proveedores-modal": {
        "label": "FOURNISSEURS",
        "heading": "Bienvenue chez ",
        "intro-1": "Rejoignez SOMOS+, un écosystème qui connecte des entrepreneurs, des professionnels et des entreprises avec la communauté hispanophone en Suisse.",
        "intro-2": "Avec une seule adhésion, vous augmentez la visibilité de votre entreprise et, en même temps, vous contribuez à générer des opportunités, du bien-être et de l'espoir pour les personnes qui en ont le plus besoin en Amérique latine.",
        "benefits-heading": "Qu'est-ce que votre adhésion comprend ?",
        "benefits-tagline": "Votre entreprise grandit. Des vies se transforment.",
        "badge-line-1": "Votre entreprise grandit.",
        "badge-line-2": "Des vies se transforment.",
        "benefit-1-title": "Profil professionnel toute l'année",
        "benefit-1-desc": "Votre entreprise visible toute l'année sur SOMOS+.",
        "benefit-2-title": "Publication de vos services",
        "benefit-2-desc": "Présentez votre entreprise de manière claire, attrayante et organisée.",
        "benefit-3-title": "3 publications par an",
        "benefit-3-desc": "Comprend 3 publications promotionnelles sur la plateforme.",
        "benefit-4-title": "Promotion sur les réseaux sociaux",
        "benefit-4-desc": "Nous promouvons votre entreprise sur Facebook, Instagram et les canaux.",
        "benefit-5-title": "Communauté WhatsApp",
        "benefit-5-desc": "Faites partie d'un réseau actif pour partager des nouvelles.",
        "benefit-6-title": "Événements et réseautage",
        "benefit-6-desc": "Accédez aux foires, réunions, formations et plus encore.",
        "benefit-7-title": "Contact avec les clients",
        "benefit-7-desc": "Les personnes intéressées pourront vous contacter.",
        "benefit-8-title": "Plus grande visibilité",
        "benefit-8-desc": "Positionnez-vous dans un écosystème de confiance dans votre langue.",
        "benefit-9-title": "Formation et croissance",
        "benefit-9-desc": "Participez à des ateliers et conférences pour renforcer votre entreprise.",
        "benefit-10-title": "Communauté avec un but",
        "benefit-10-desc": "20% est destiné à des projets sociaux en Amérique latine.",
        "price-label": "Votre investissement",
        "price-period": "CHF / an",
        "price-amount": "360",
        "price-note": "Environ CHF 1 par jour.",
        "price-freeze": "La valeur de votre adhésion restera gelée pendant 2 ans pour ceux qui s'inscrivent à cette étape.",
        "price-promise": "Pas d'augmentations. Pas de surprises.",
        "impact-heading": "Plus qu'une adhésion, un vrai impact",
        "impact-1": "Votre entreprise gagne en visibilité, en nouveaux clients et en opportunités.",
        "impact-2": "Vous renforcez votre positionnement au sein de la communauté hispanophone.",
        "impact-3": "Vous contribuez à transformer des vies à travers des projets sociaux.",
        "cta-heading": "Voulez-vous faire partie de SOMOS+ ?",
        "cta-desc": "Écrivez-nous et nous vous accompagnerons avec plaisir tout au long du processus.",
        "close": "Fermer"
      }
    },
    "provider-analytics": {
      "loading": "Chargement des statistiques...",
      "title": "Analytique du fournisseur",
      "subtitle": "Performance et portée de votre entreprise",
      "total-favorites": "Total des favoris",
      "favorites-desc": "Utilisateurs qui ont enregistré votre profil",
      "saved-events": "Événements enregistrés",
      "events-desc": "Intérêt pour vos {{count}} événements actifs",
      "community-reach": "Portée communautaire",
      "reach-desc": "Total des interactions positives",
      "cta-title": "Boostez votre visibilité !",
      "cta-desc": "Les entreprises qui publient régulièrement des événements ont 40 % plus de chances d'être ajoutées aux favoris. Publiez quelque chose de nouveau aujourd'hui !",
      "manage-events": "Gérer mes événements"
    },
  "provider-dashboard": {
      "title": "Portail fournisseur de services",
      "card-1": "Mon entreprise",
      "text-1": "Gérez votre présence publique sur la carte.",
      "button-1": "Gérer les services",
      "card-2": "Annonces",
      "text-2": "Publiez des événements ou des ventes pour la communauté.",
      "button-2": "Gérer les événements",
      "card-3": "Analytique",
      "text-3": "Voir combien d'utilisateurs ont cliqué sur votre épingle.",
      "button-3": "Voir les statistiques"
    },
    "profile": {  
      "title": "Paramètres utilisateur",
      "account": "Compte",
      "full-name": "Nom d'utilisateur",
      "user": "Utilisateur",
      "provider": "Fournisseur",
      "admin": "Administrateur",
      "email": "E-mail",
      "email-not-changed": "L'e-mail ne peut pas être modifié",
      "password": "Mot de passe",
      "language": "Langue",
      "English": "Anglais",
      "Spanish": "Espagnol",
      "French": "Français",
      "German": "Allemand",
      "location": "Emplacement",
      "default-location": "Emplacement par défaut",
      "custom-location": "Emplacement personnalisé",
      "location-help": "Définissez où la carte sera centrée lorsque vous vous connectez. Vous pouvez saisir une ville ou cliquer sur la carte.",
      "location-placeholder": "Définissez votre emplacement en cliquant sur la carte",
      "search-location": "Rechercher une ville, un code postal ou une adresse",
      "find-location": "Rechercher",
      "profile-loading": "Chargement du profil...",
      "update-profile": "Mettre à jour le profil",
      "not-a-member": "Pas encore membre?",
      "buttons": {
          "update-profile": "Mettre à jour le profil",
          "loading": "Chargement...",
      },
      "alerts": {
          "profile-update-success": "Profil mis à jour avec succès !",
          "profile-update-error": "Erreur lors de la mise à jour du profil. Veuillez réessayer ou contacter le support.",
          "profile-access": "Vous ne pouvez modifier que votre propre profil.",
          "agree-terms-conditions":"Vous devez accepter les conditions d'utilisation pour vous inscrire.",
          "registration-failed": "Erreur d'inscription. Veuillez réessayer ou contacter le support.",
          "no-active-listings":"Vous n'avez aucune annonce active. Ajoutez des services à votre compte.",
          "confirm-delete-listing": "Êtes-vous sûr de vouloir annuler cette offre ? Elle sera retirée de la carte.",
          "error-deleting-listing": "Erreur lors de la suppression de l'offre de service.",
      },
     "welcome": {
        "access-tools": "Accédez à vos outils pour vous connecter avec la communauté locale.",
        "already-member": "Déjà membre?",
        "agree-terms": "En m'inscrivant, j'accepte les ",
        "here-to": "Je suis ici pour:",
        "find-services": "Trouver des services",
        "offer-services": "Offrir des services",
        "find-services-desc": "Je veux rechercher et marquer des favoris.",
        "offer-services-desc": "Je veux lister mes services sur la carte et créer des événements.",
        "create-account": "Créer un compte",
        "register-title": "Rejoignez somosmas",
        "register-subtitle": "Nous sommes plus qu'une carte. Nous sommes une communauté.",
        "create-account-button": "Créer un compte", 
     },
     "favorites": {
      "welcome": "Content de vous revoir, ",
      "subtitle": "Voici vos événements enregistrés et vos prestataires de service favoris.",
      "saved-events": "Événements enregistrés",
      "favorite-providers": "Services favoris",
      "my-events": "Mes événements",
      "favorite-services": "Mes services favoris",
      "browse-events": "Parcourir les événements",
      "explore-map": "Explorer la carte",
      "open-route": "Ouvrir l'itinéraire",
      "visit-website": "Visiter le site",
      "save-calendar": "Enregistrer dans le calendrier",
      "remove-favorite": "Retirer des favoris",
      "view-details": "Voir les détails",
      "no-events": "Vous n'avez pas encore enregistré d'événements.",
      "find-events": "Trouver des événements",
      "no-places": "Pas encore de lieux favoris.",
      "go-to-map": "Aller à la carte",
      "unknown-venue": "Lieu inconnu",
      "alerts": {
        "remove-event": "Supprimer cet événement de votre tableau de bord ?",
        "unpin-place": "Détacher ce lieu ?"
      },
      },
     "service-profile":{
      "title": "Modifier le profil du service",
        "title-create": "Créer un nouveau profil de service",
        "subtitle": "Mettez à jour l'apparence de votre service sur la carte.",
        "subtitle-create": "Ajoutez à votre compte un nouveau service à afficher sur la carte.",
        "business-name":"Nom du service",
        "description": "Description",
        "refine-location":"Affiner l'emplacement",
        "website":"Site web",
        "placeholder-email":"ex. info@entreprise.com",
        "placeholder-phone":"ex. +41 79 123 45 67",
        "placeholder-location": "Saisissez l'adresse (ex. Lowenstrasse 10, Zurich)",
        "preferred-contact":"Comment les clients doivent-ils vous contacter ?",
        "address":"Adresse",
        "latitude":"Latitude",
        "longitude":"Longitude",
        "fine-tune": "Ou placez la souris sur la carte pour affiner l'emplacement.",
        "save-changes": "Enregistrer les modifications",
        "create-service": "Créer le service",
        "photo": "Photo du service",
        "image-hint": "JPG ou PNG, max 5 Mo",
        "alerts":{
          "error-saving-profile": "Erreur lors de l'enregistrement du profil.",
          "changes-saved": "Modifications enregistrées avec succès.",
          "contact-recommended": "Nous recommandons d'ajouter au moins un téléphone ou un email.",
          "error-loading": "Erreur lors du chargement des détails du service."
        }
     }
    },
    "general": { 
      "install-app": "Installer somos+ app",
      "apply": "Appliquer", 
      "approve": "Approuver", 
      "back": "Retour",
      "cancel": "Annuler",
      "close": "Fermer",
      "confirm": "Confirmer",
      "page-not-found": "Page introuvable",
      "page-not-found-desc": "La page que vous recherchez n'existe pas.",
      "go-home": "Retour à l'accueil",
      "delete": "Supprimer",
      "edit": "Éditer",
      "enter": "Entrer",
      "find": "Trouver",
      "loading": "Chargement...",
      "next": "Suivant",
      "no": "Non",
      "processing": "Traitement...",
      "reject": "Rejeter",
      "reset": "Réinitialiser",
      "save": "Enregistrer",
      "search": "Rechercher",
      "searching": "Recherche...",
      "select": "Sélectionner",
      "selected": "Sélectionné",
      "submit": "Soumettre",
      "update": "Mettre à jour",
      "view": "Voir",
      "yes": "Oui",
      "alerts": {
        "registration-success" : "Opération réussie ! Veuillez consulter votre boîte mail pour confirmer votre adresse (pensez à vérifier votre dossier de courrier indésirable).",
        "action-success": "Action réussie !",
        "action-error": "Erreur lors de l'exécution de l'action. Veuillez réessayer ou contacter le support.",
        "address-not-found": "Adresse introuvable. Veuillez essayer une autre adresse." ,
        "error-geocoding": "Erreur lors de la géocodification de l'adresse. Veuillez réessayer plus tard.",
        "save-favourites": "Veuillez vous connecter pour sauvegarder en favoris.",
        "error-geolocation": "Impossible de récupérer votre position."
      },
      "time":{
        "days":{
          "monday": "Lundi",
          "tuesday": "Mardi",
          "wednesday": "Mercredi",
          "thursday": "Jeudi",
          "friday": "Vendredi",
          "saturday": "Samedi",
          "sunday": "Dimanche"
        },
        "hours":{
          "24-7": "24/7",
          "add-hours": "Ajouter des heures",
          "alert-monday": "Les heures de lundi à dimanche doivent être définies avant d'ajouter des heures spécifiques.",
          "alert-confirm-reset": "Êtes-vous sûr de vouloir réinitialiser les heures d'ouverture? Toutes les heures personnalisées seront perdues.",
          "business-hours": "Heures d'ouverture",
          "closed": "Fermé",
          "closes-at": "Ferme à",
          "copy-monday": "Copier lundi a toutes les autres journées",
          "day": "Jour",
          "hours": "Heures",
          "hours-help": "Définissez les heures d'ouverture de votre entreprise. Vous pouvez ajouter plusieurs plages horaires par jour.",
          "open": "Ouvert",
          "opens-at": "Ouvre à",
          "remove-hours": "Supprimer les heures",
          "to": "à",
          "variable-hours": "Heures variables"
        },
      },
      "install-prompt": {
        "title": "Installer l'application",
        "tap": "Appuyez sur",
        "share-then": "l'icône \"Partager\" puis",
        "add-to-home": "\"Ajouter à l'écran d'accueil\""
      },
  }
  }
  }
};

// 2. Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

// Async initializer to ensure i18n is ready and apply saved client lang
export async function initI18n() {
  // if already initialized, just apply stored lang
  if (i18n.isInitialized) {
    const stored = localStorage.getItem('lang');
    if (stored && stored !== i18n.language) {
      try { await i18n.changeLanguage(stored); } catch (e) { i18n.language = stored; }
    }
    return i18n;
  }

  // Since resources are provided synchronously, just wait a tick to ensure init is complete
  await new Promise((resolve) => setTimeout(resolve, 0));

  const stored = localStorage.getItem('lang');
  if (stored && stored !== i18n.language) {
    try { await i18n.changeLanguage(stored); } catch (e) { i18n.language = stored; }
  }
  return i18n;
}

export default i18n;
